{
  "notice": {
    "pro": {
      "ai_visibility": {
        "title": "Nieuw: AI Zichtbaarheid",
        "body": "Zie hoe je merk verschijnt in ChatGPT, Perplexity en Google AI-overzichten.",
        "primary": "Open AI Zichtbaarheid",
        "secondary": "Later misschien"
      }
    }
  },
  "nav": {
    "overview": "Overzicht",
    "review": "Beoordelen",
    "brands": "Merken",
    "analytics": "Analyses",
    "aiVisibility": "AI-zichtbaarheid",
    "engagement": "Engagement",
    "ads": "Ads",
    "calendar": "Agenda",
    "discover": "Ontdekken",
    "posts": "Posts",
    "usage": "Gebruik",
    "settings": "Instellingen",
    "general": "Algemeen",
    "profile": "Profiel",
    "members": "Leden",
    "connections": "Verbindingen",
    "connectedApps": "Verbonden apps",
    "cadence": "Cadans",
    "carouselTemplates": "Carrousel-templates",
    "reports": "Rapporten",
    "autoResponses": "Auto-reacties",
    "billing": "Facturatie",
    "privacy": "Privacy",
    "privacyData": "Privacy & gegevens",
    "storylines": "Verhaallijnen",
    "blog": "Blog"
  },
  "sidebar": {
    "sectionMain": "HOOFD",
    "sectionContent": "CONTENT",
    "sectionGrowth": "GROEI",
    "sectionSettings": "INSTELLINGEN",
    "sectionAdmin": "ADMIN"
  },
  "topbar": {
    "searchPlaceholder": "Zoek posts, merken, verbindingen...",
    "searchNoResults": "Geen resultaten voor \"{{query}}\"",
    "searchPage": "Pagina",
    "searchBrand": "Merk",
    "notifications": "Meldingen",
    "notificationsUnread": "Meldingen — {{count}} ongelezen",
    "accountMenu": "Accountmenu",
    "accountFallback": "Account"
  },
  "dashboard": {
    "greeting": "Goedemorgen,",
    "greetingAfternoon": "Goedemiddag,",
    "greetingEvening": "Goedenavond,",
    "postsWaitingReview": "Je hebt <strong>{{count}}</strong> posts die wachten op beoordeling",
    "unreadInboxItems_one": "en <strong>{{count}}</strong> ongelezen bericht",
    "unreadInboxItems_other": "en <strong>{{count}}</strong> ongelezen berichten",
    "allCaughtUp": "Alles bijgewerkt. Top werk!",
    "generatePost": "Post genereren",
    "generateBlog": "Blog genereren",
    "generate": "Genereren",
    "writePost": "Post schrijven",
    "engage": "Reageren",
    "postsPublishedChart": "Gepubliceerde posts",
    "last30DaysByPlatform": "Laatste 30 dagen per platform",
    "platformSplit": "Verdeling per platform",
    "postsByPlatform": "Posts per platform",
    "recentPosts": "Recente posts",
    "latestActivity": "Laatste activiteit op alle platforms",
    "liveActivity": "Live activiteit",
    "viewReports": "Rapporten bekijken",
    "noDataYet": "Nog geen platformgegevens",
    "firstPostsMonday": "Merkflow genereert je eerste posts op maandag.",
    "noRecentPosts": "Nog geen recente posts",
    "youHave": "Je hebt",
    "pendingPostsCount_one": "{{count}} post die wacht op beoordeling",
    "pendingPostsCount_other": "{{count}} posts die wachten op beoordeling",
    "unreadInboxCount_one": "{{count}} ongelezen bericht",
    "unreadInboxCount_other": "{{count}} ongelezen berichten",
    "someone": "Iemand"
  },
  "join": {
    "loading": "Je uitnodiging wordt gecontroleerd…",
    "subtitle": "Je bent uitgenodigd om Merkflow te proberen",
    "invitedMessage": "Met Merkflow beheer je social media voor meerdere merken met AI. Maak hieronder je account aan.",
    "bypassFailed": "We konden je uitnodiging niet valideren. Probeer de link opnieuw of vraag het aan de afzender.",
    "invalid": {
      "title": "Uitnodiging niet geldig",
      "expired": "Deze uitnodigingslink is verlopen. Vraag een nieuwe aan de afzender.",
      "maxed": "Deze uitnodigingslink heeft het maximum aantal keer gebruikt.",
      "disabled": "Deze uitnodigingslink is niet meer actief.",
      "not_found": "We konden geen uitnodigingslink met deze code vinden. Controleer de URL."
    }
  },
  "feedback": {
    "button": "Feedback",
    "title": "Feedback sturen",
    "category": "Categorie",
    "category.bug": "Bug",
    "category.feature_request": "Wens",
    "category.general": "Algemeen",
    "category.question": "Vraag",
    "titleField": "Titel",
    "titlePlaceholder": "Korte samenvatting van wat je wilt melden",
    "description": "Beschrijving",
    "descriptionPlaceholder": "Stappen om te reproduceren, wat je verwachtte, wat er gebeurde…",
    "screenshot": "Screenshot (optioneel)",
    "attachScreenshot": "Screenshot toevoegen",
    "captureScreen": "Scherm vastleggen",
    "capturing": "Vastleggen…",
    "captureFailed": "Kon het scherm niet vastleggen. Probeer een afbeelding te uploaden.",
    "uploadImage": "Afbeelding uploaden",
    "screenshotAttached": "Screenshot toegevoegd",
    "pageContext": "Gerapporteerd vanaf {{path}}",
    "submit": "Feedback sturen",
    "rateLimited": "Je hebt de daglimiet voor feedback bereikt. Probeer het morgen opnieuw.",
    "disabled": "Feedback is momenteel uitgeschakeld.",
    "success": {
      "title": "Bedankt voor je feedback!",
      "message": "We kijken ernaar en nemen contact op als we meer info nodig hebben."
    }
  },
  "waitlisted": {
    "title": "Je staat op de wachtlijst",
    "description": "Bedankt voor je aanmelding en het invullen van je profiel — alles is opgeslagen. Registratie is momenteel alleen op uitnodiging, dus je account is nog niet actief. We mailen je zodra er een plek vrijkomt en je proefperiode start."
  },
  "waitlist": {
    "title": "Toegang aanvragen",
    "subtitle": "Registratie is momenteel alleen op uitnodiging. Laat je gegevens achter en we laten je weten zodra er een plek vrijkomt.",
    "name": "Volledige naam *",
    "email": "E-mail *",
    "company": "Bedrijf",
    "useCase": "Waarvoor ga je Merkflow gebruiken?",
    "submit": "Toegang aanvragen",
    "success": {
      "title": "Je staat op de lijst!",
      "message": "We mailen je op {{email}} zodra je toegang klaar is."
    },
    "duplicate": "Je hebt al toegang aangevraagd. We nemen contact op.",
    "rateLimited": "Te veel verzoeken vanuit dit netwerk. Probeer het over een uur opnieuw."
  },
  "starterGate": {
    "upgradeCta": "Upgrade naar Pro",
    "analytics": {
      "title": "Analytics is een Pro-functie",
      "description": "Gedetailleerde prestatierapporten, per-platform overzichten en engagement-trends zijn beschikbaar als je upgradet."
    },
    "aiVisibility": {
      "title": "AI-zichtbaarheid is een Pro-functie",
      "description": "Zie hoe ChatGPT, Perplexity en Google AI Overviews over je merk praten. Voer probes uit, dicht hiaten en volg je AI-zoekscore op Pro."
    },
    "ads": {
      "title": "Meta Ads is een Pro-functie",
      "description": "Beheer Facebook- en Instagram-advertentiecampagnes vanuit Merkflow op Pro."
    },
    "storylines": {
      "title": "Storylines is een Pro-functie",
      "description": "Plan meerwekelijkse verhaallijnen over je kanalen. Beschikbaar op Pro."
    },
    "calendar": {
      "title": "Kalender is een Pro-functie",
      "description": "Visuele maandkalender voor al je merken en platforms. Beschikbaar op Pro."
    },
    "discover": {
      "title": "Ontdekken is een Pro-functie",
      "description": "Trending onderwerpen, marktinformatie en concurrentievergelijking. Beschikbaar op Pro."
    },
    "blog": {
      "title": "Blog-generatie is een Pro-functie",
      "description": "Genereer automatisch WordPress-blog-drafts om je AI-zichtbaarheid te verhogen. Beschikbaar op Pro."
    },
    "usage": {
      "title": "Verbruiksanalyse is een Pro-functie",
      "description": "Gedetailleerde AI-kostenuitsplitsing per model, merk en operatie. Beschikbaar op Pro."
    }
  },
  "starterOverview": {
    "generateHint": "Laat AI je volgende post schrijven",
    "writeHint": "Schrijf zelf een post",
    "reviewQueue": "Posts klaar voor je beoordeling"
  },
  "common": {
    "save": "Opslaan",
    "cancel": "Annuleren",
    "notNow": "Niet nu",
    "upgradeToUnlock": "Upgrade om te ontgrendelen",
    "delete": "Verwijderen",
    "edit": "Bewerken",
    "add": "Toevoegen",
    "loading": "Laden...",
    "loadingShort": "Laden…",
    "confirm": "Bevestigen",
    "close": "Sluiten",
    "back": "Terug",
    "next": "Volgende",
    "previous": "Vorige",
    "search": "Zoeken",
    "noResults": "Geen resultaten gevonden",
    "required": "Verplicht",
    "optional": "Optioneel",
    "learnMore": "Meer informatie",
    "viewAll": "Alles bekijken",
    "refresh": "Vernieuwen",
    "retry": "Opnieuw proberen",
    "enable": "Inschakelen",
    "disable": "Uitschakelen",
    "enabled": "Ingeschakeld",
    "disabled": "Uitgeschakeld",
    "weekdays": {
      "monday": "Maandag",
      "tuesday": "Dinsdag",
      "wednesday": "Woensdag",
      "thursday": "Donderdag",
      "friday": "Vrijdag",
      "saturday": "Zaterdag",
      "sunday": "Zondag"
    },
    "active": "Actief",
    "inactive": "Inactief",
    "yes": "Ja",
    "no": "Nee",
    "or": "of",
    "and": "en",
    "copied": "Gekopieerd!",
    "copy": "Kopiëren",
    "select": "Kiezen",
    "all": "Alle",
    "loadMore": "Meer laden",
    "saveChanges": "Wijzigingen opslaan",
    "discard": "Verwerpen",
    "areYouSure": "Weet je het zeker?",
    "remove": "Verwijderen",
    "uploading": "Uploaden…",
    "pending": "In behandeling",
    "rejected": "Afgewezen",
    "saved": "Opgeslagen",
    "saving": "Opslaan…",
    "sending": "Versturen…",
    "testing": "Testen…",
    "filter": "Filter",
    "create": "Aanmaken",
    "createBrand": "Merk aanmaken",
    "connect": "Verbinden",
    "connected": "Verbonden",
    "notConnected": "Niet verbonden",
    "done": "Klaar",
    "comingSoon": "Binnenkort beschikbaar",
    "today": "Vandaag",
    "failed": "Mislukt",
    "showPassword": "Wachtwoord tonen",
    "hidePassword": "Wachtwoord verbergen",
    "backToSignIn": "Terug naar inloggen",
    "backToDashboard": "Terug naar dashboard",
    "nevermind": "Laat maar",
    "inWord": "in",
    "youSuffix": "(jij)",
    "google": "Google",
    "undo": "Ongedaan maken",
    "redo": "Opnieuw",
    "bold": "Vet",
    "italic": "Cursief",
    "underline": "Onderstreept",
    "platforms": "Platforms",
    "recently": "recent",
    "expandSidebar": "Zijbalk uitklappen",
    "collapseSidebar": "Zijbalk inklappen",
    "openMenu": "Menu openen",
    "errorTitle": "Er ging iets mis"
  },
  "errors": {
    "generic": "Er ging iets mis. Probeer het opnieuw.",
    "network": "Netwerkfout. Controleer je verbinding.",
    "unauthorized": "Je bent niet bevoegd om dit te doen.",
    "notFound": "Niet gevonden.",
    "validation": "Controleer het formulier op fouten.",
    "serverError": "Serverfout. We zijn ermee bezig.",
    "forbidden": "Je hebt hier geen toegang toe.",
    "ownerOnly": "Alleen de workspace-eigenaar kan dit doen.",
    "featureNotAvailable": "Upgrade om deze functie te gebruiken",
    "featureUpgradeHint": "Deze functie zit in een hoger abonnement. Bekijk de plannen of upgrade nu om hem te ontgrendelen.",
    "viewPlans": "Bekijk plannen",
    "trialExpired": "Je proefperiode is verlopen. Upgrade om door te gaan.",
    "trialExpiredTooltip": "Je proefperiode is afgelopen — upgrade om posts te blijven maken.",
    "workspacePausedTooltip": "Deze werkruimte is gepauzeerd — upgrade of heractiveer je abonnement.",
    "planLimit": "Je abonnement ondersteunt deze functie niet.",
    "publishFailed": "Kon de post niet publiceren.",
    "connectionExpired": "Verbinding verlopen. Maak opnieuw verbinding met je account.",
    "disconnectFailed": "Verbreken mislukt.",
    "saveFailed": "Opslaan mislukt. Probeer het opnieuw.",
    "loginFailed": "Inloggen mislukt. Probeer het opnieuw.",
    "verificationEmailFailed": "Kon de verificatiemail niet versturen. Probeer het later opnieuw.",
    "workspaceCreationFailed": "Werkruimte aanmaken mislukt. Probeer het opnieuw.",
    "createWorkspaceFailed": "Werkruimte aanmaken mislukt (HTTP {{status}}).",
    "createWorkspaceGeneric": "Werkruimte aanmaken mislukt. Probeer het opnieuw.",
    "chunkLoadError": "Er ging iets mis",
    "chunkLoadHelp": "Probeer de pagina te vernieuwen. Blijft het probleem, log dan uit en weer in.",
    "reload": "Opnieuw laden",
    "unexpectedTitle": "Er ging iets mis",
    "unexpectedHelp": "Deze pagina liep tegen een onverwachte fout aan. Probeer opnieuw, of herlaad als het blijft gebeuren.",
    "tryAgain": "Opnieuw proberen"
  },
  "auth": {
    "signIn": "Inloggen",
    "signOut": "Uitloggen",
    "signInWithGoogle": "Inloggen met Google",
    "signInTitle": "Inloggen bij Merkflow",
    "signInSubtitle": "Log in op je Merkflow-account",
    "continueWithGoogle": "Doorgaan met Google",
    "continueWithLinkedIn": "Doorgaan met LinkedIn",
    "welcomeBack": "Welkom terug",
    "email": "E-mailadres",
    "password": "Wachtwoord",
    "forgotPassword": "Wachtwoord vergeten?",
    "noAccount": "Nog geen account?",
    "alreadyAccount": "Heb je al een account?",
    "register": "Account aanmaken",
    "createAccount": "Account aanmaken",
    "createAccountSubtitle": "Maak je Merkflow-account aan",
    "emailVerified": "E-mail geverifieerd. Je kunt nu inloggen.",
    "verificationEmailSent": "Verificatiemail verstuurd! Controleer je inbox.",
    "startFreeTrial": "Start je gratis proefperiode",
    "resendVerificationEmail": "Verificatiemail opnieuw versturen",
    "passwordValidation": "Wachtwoord moet minimaal 8 tekens hebben en een cijfer bevatten.",
    "passwordRequirements": "Min. 8 tekens met minstens één cijfer",
    "trialInfo": "{{days}} dagen gratis proberen. Geen creditcard nodig.",
    "registrationClosed": {
      "title": "Registratie gesloten",
      "message": "We accepteren op dit moment geen nieuwe aanmeldingen. Heb je een uitnodiging om te testen? Check je inbox voor de uitnodigingslink."
    },
    "checkEmail": "Controleer je e-mail",
    "verificationSentTo": "We hebben een verificatielink gestuurd naar",
    "verifyAccount": "Klik erop om je account te verifiëren en te beginnen.",
    "fullName": "Volledige naam",
    "forgotPasswordSubtitle": "Wachtwoord vergeten?",
    "forgotPasswordDescription": "Vul je e-mailadres in en we sturen je een link om het te resetten.",
    "sendResetLink": "Resetlink versturen",
    "resetLinkSent": "Als er een account bestaat voor",
    "resetLinkSentDesc": "hebben we een wachtwoordresetlink verstuurd.",
    "setNewPassword": "Stel een nieuw wachtwoord in",
    "newPassword": "Nieuw wachtwoord",
    "confirmPassword": "Wachtwoord bevestigen",
    "passwordsMismatch": "Wachtwoorden komen niet overeen",
    "invalidResetToken": "Ongeldige of ontbrekende resettoken.",
    "resetPassword": "Wachtwoord resetten",
    "invalidResetLink": "Ongeldige resetlink",
    "resetLinkExpired": "Deze resetlink is ongeldig of verlopen.",
    "requestNewLink": "Nieuwe link aanvragen"
  },
  "settings": {
    "title": "Instellingen",
    "language": "Taal",
    "languageDescription": "Kies de taal voor de Merkflow-interface.",
    "dutch": "Nederlands",
    "english": "Engels",
    "languageSaved": "Taal bijgewerkt.",
    "general": "Algemeen",
    "approval": {
      "title": "Goedkeuringsmeldingen",
      "description": "Ontvang een e-mail wanneer nieuwe posts klaar zijn voor beoordeling. Voeg de adressen toe die een melding moeten krijgen — een lege lijst valt terug op de eigenaar van de werkruimte.",
      "addEmail": "E-mailadres toevoegen",
      "saved": "Meldingsvoorkeuren opgeslagen",
      "emptyHint": "Nog geen ontvangers — de eigenaar van de werkruimte krijgt de melding.",
      "smtpMissing": "Er is geen SMTP geconfigureerd voor deze werkruimte en er is geen platform-brede fallback. Ontvangers die je hier toevoegt krijgen geen e-mail totdat SMTP wordt ingesteld via Instellingen → Verbonden apps → E-mail, of een beheerder de globale SMTP configureert."
    },
    "showcase": {
      "title": "Openbare showcase",
      "label": "Merkflow mag mijn posts tonen op de website",
      "help": "Als je dit aanzet, kunnen recent gepubliceerde posts van deze workspace verschijnen in de openbare showcase op merkflow.eu. Alleen door Merkflow gegenereerde posts, nooit gesynchroniseerde posts van derden. Je kunt dit altijd weer uitzetten.",
      "saved": "Showcase-voorkeur opgeslagen"
    },
    "autoResponses": {
      "title": "Auto-reacties",
      "subtitle": "Reageer automatisch op reacties en vermeldingen op basis van regels.",
      "create": "Regel aanmaken",
      "edit": "Regel bewerken",
      "save": "Regel opslaan",
      "name": "Regelnaam",
      "namePlaceholder": "bv. Reacties op prijsvragen",
      "brand": "Merk",
      "allBrands": "Alle merken",
      "allPlatforms": "Alle platforms",
      "platforms": "Platforms",
      "platformsHint": "Laat leeg om alle gekoppelde platforms te dekken.",
      "triggerLabel": "Trigger",
      "trigger": {
        "keyword": "Bevat zoekwoord",
        "sentiment": "Sentiment is",
        "all": "Alle reacties",
        "keywordWith": "Zoekwoord: {{keywords}}",
        "sentimentWith": "Sentiment is {{sentiment}}"
      },
      "keywordPlaceholder": "prijs, kosten, abonnement",
      "selectSentiment": "Kies sentiment",
      "sentiment": {
        "positive": "Positief",
        "neutral": "Neutraal",
        "negative": "Negatief",
        "question": "Vraag"
      },
      "responseLabel": "Antwoord",
      "response": {
        "template": "Vast antwoord",
        "ai": "AI-suggestie gebruiken"
      },
      "templatePlaceholder": "Bedankt voor je bericht! We nemen snel contact op.",
      "aiHint": "Gebruikt de AI-gegenereerde reactie die naast elke comment wordt opgeslagen.",
      "requireReview": "Controleren voor verzending",
      "maxPerHour": "Max reacties per uur",
      "maxPerHourHint": "Limiet per regel. Standaard 10. Voorkomt overspraak als een post viraal gaat.",
      "repliesSent_one": "{{count}} reactie verzonden",
      "repliesSent_other": "{{count}} reacties verzonden",
      "deleteConfirmTitle": "Deze regel verwijderen?",
      "deleteConfirmMessage": "{{name}} stopt met automatisch reageren. Eerdere auto-reacties blijven in het auditlogboek staan.",
      "deleted": "Regel verwijderd",
      "empty": {
        "title": "Nog geen auto-reacties",
        "description": "Reageer automatisch op reacties die voldoen aan een zoekwoord of sentiment."
      },
      "errors": {
        "nameRequired": "Regelnaam is verplicht.",
        "keywordRequired": "Voeg minstens één zoekwoord toe.",
        "templateRequired": "Voeg een vast antwoord toe.",
        "maxPerHourRange": "Max reacties per uur moet 1..1000 zijn."
      },
      "upgradeTitle": "Auto-reacties is een Pro-functie",
      "upgradeDescription": "Reageer automatisch op reacties en vermeldingen op basis van zoekwoord- of sentimentregels. Beschikbaar op Pro."
    },
    "reports": {
      "title": "Geplande rapporten",
      "subtitle": "Stuur automatisch terugkerende analyse-PDF's naar je team of klanten zonder dat ze hoeven in te loggen.",
      "create": "Planning toevoegen",
      "edit": "Planning bewerken",
      "save": "Planning opslaan",
      "frequency": "Frequentie",
      "weekly": "Wekelijks",
      "monthly": "Maandelijks",
      "day": "Dag",
      "dayOfMonth": "Dag {{day}} van elke maand",
      "time": "Tijd (UTC)",
      "brand": "Merk",
      "allBrands": "Alle merken",
      "recipients": "Ontvangers",
      "recipientsHint": "E-mailadressen gescheiden door komma's of puntkomma's.",
      "recipientCount_one": "{{count}} ontvanger",
      "recipientCount_other": "{{count}} ontvangers",
      "sendNow": "Nu versturen",
      "lastSent": "Laatst verzonden {{date}}",
      "neverSent": "Nog nooit verzonden",
      "lastError": "Laatste fout",
      "deleted": "Planning verwijderd",
      "saved": "Planning opgeslagen",
      "sent": "Rapport verzonden",
      "deleteConfirmTitle": "Deze planning verwijderen?",
      "deleteConfirmMessage": "Ontvangers krijgen dit rapport niet meer. Je kunt het later opnieuw aanmaken.",
      "empty": {
        "title": "Geen geplande rapporten",
        "description": "Stuur automatisch analyse-PDF's naar je team of klanten."
      },
      "errors": {
        "noRecipients": "Voeg minstens één e-mailontvanger toe."
      },
      "upgradeTitle": "Geplande rapporten is een Pro-functie",
      "upgradeDescription": "Stuur automatisch wekelijkse of maandelijkse analyse-PDF's naar je team en klanten. Beschikbaar op Pro."
    },
    "profile": "Profiel",
    "profileSubtitle": "Je persoonlijke accountgegevens",
    "name": "Naam",
    "email": "E-mail",
    "emailAddress": "E-mailadres",
    "avatar": "Profielfoto",
    "saveProfile": "Profiel opslaan",
    "profileSaved": "Profiel opgeslagen.",
    "profilePicture": "Profielfoto",
    "profileManagedByGoogle": "Je profielfoto wordt beheerd door je Google-account.",
    "avatarUploadComingSoon": "Avatar-upload volgt in een volgende update.",
    "signedInWith": "Ingelogd met",
    "accountInformation": "Accountgegevens",
    "displayName": "Weergavenaam",
    "yourName": "Je naam",
    "verified": "Geverifieerd",
    "emailManagedByGoogle": "E-mail wordt beheerd door je Google-account en kan hier niet worden gewijzigd.",
    "danger": "Gevarenzone",
    "deleteAccount": "Account verwijderen",
    "deleteAccountWarning": "Deze actie kan niet ongedaan worden gemaakt.",
    "inviteMember": "Lid uitnodigen",
    "inviteByEmail": "Uitnodigen via e-mail",
    "sendInvite": "Uitnodiging versturen",
    "pendingInvite": "Openstaande uitnodiging",
    "leaveWorkspace": "Werkruimte verlaten",
    "billing": "Facturatie",
    "currentPlan": "Huidig abonnement",
    "roleOwner": "Eigenaar",
    "roleMember": "Lid",
    "roleAdmin": "Admin",
    "roleApprover": "Goedkeurder",
    "appearance": "Weergave",
    "interfaceMode": "Interface-modus",
    "interfaceModeDesc": "Kies je voorkeurskleurenschema.",
    "accentColor": "Accentkleur",
    "accentColorDesc": "Kies een kleur uit het palet of plak een hex-code. Wordt automatisch opgeslagen.",
    "flameColor": "Vlam",
    "account": "Account",
    "accountDescription": "Profielinstellingen, e-mailvoorkeuren en wachtwoordbeheer komen in de volgende iteratie.",
    "namePlaceholder": "Je naam",
    "emailLabel": "E-mailadres",
    "emailEditableHint": "Je kunt je e-mail hier niet wijzigen. Neem contact op met support als dit nodig is.",
    "emailSocialHint": "Beheerd via je {{provider}}-account.",
    "changePassword": "Wachtwoord wijzigen",
    "passwordCurrent": "Huidig wachtwoord",
    "passwordNew": "Nieuw wachtwoord",
    "passwordRules": "Minstens 8 tekens en één cijfer.",
    "passwordCurrentWrong": "Huidig wachtwoord klopt niet.",
    "passwordTooWeak": "Wachtwoord moet minstens 8 tekens en een cijfer bevatten.",
    "passwordChangeFailed": "Wachtwoord wijzigen mislukt.",
    "passwordUpdated": "Wachtwoord bijgewerkt. Log opnieuw in.",
    "exportData": "Exporteer je gegevens",
    "exportDataDesc": "Download een JSON-archief van je account en posts (AVG).",
    "exportStarted": "Je download begint.",
    "exportFailed": "Export mislukt",
    "deleteAccountTitle": "Dit account verwijderen?",
    "deleteAccountConfirm": "Verwijder je account",
    "deleteAccountDesc": "Verwijder je account permanent na 14 dagen respijt.",
    "deletionRequested": "Account-verwijdering ingepland. Bekijk je e-mail voor details.",
    "deletionFailed": "Verzoek tot verwijderen is mislukt — probeer het opnieuw.",
    "savedToast": "Opgeslagen.",
    "saveFailedToast": "Wijzigingen opslaan mislukt.",
    "light": "Licht",
    "dark": "Donker",
    "lightMode": "Overschakelen naar lichte modus",
    "darkMode": "Overschakelen naar donkere modus",
    "switchLanguage": "Taal wisselen",
    "manageWorkspace": "Beheer je account- en werkruimtevoorkeuren.",
    "membership": "Lidmaatschap",
    "memberSince": "Lid sinds {{date}}",
    "managePlan": "Abonnement beheren",
    "contactOwner": "Neem contact op met de werkruimte-eigenaar om het abonnement te beheren.",
    "connectedAppsDescription": "Externe diensten en uitgaande e-mail.",
    "emailApp": "E-mail",
    "googleWorkspaceSMTP": "Google Workspace / SMTP",
    "smtpDescription": "Verstuur teamuitnodigingen en transactionele e-mails vanaf je eigen adres in plaats van noreply@merkflow.eu.",
    "smtpFrom": "Van",
    "smtpHost": "Host",
    "smtpConnected": "Verbonden",
    "connectEmail": "E-mail verbinden",
    "editEmail": "E-mailverbinding bewerken",
    "emailSubtitle": "Verstuur teamuitnodigingen + transactionele e-mail vanaf je eigen adres.",
    "disconnectEmailConfirm": "Dit e-mailaccount verbreken? Toekomstige e-mails gebruiken weer de standaard Merkflow-afzender.",
    "emailOwnerOnly": "Alleen werkruimte-eigenaren kunnen e-mail configureren.",
    "googleAppPasswordTitle": "Zo krijg je een Google Workspace App-wachtwoord",
    "step1": "Zet 2-staps-verificatie aan op {{url}}",
    "step2": "Ga naar {{url}}",
    "step3": "Typ een naam zoals Merkflow en klik op Create",
    "step4": "Kopieer het 16 tekens lange wachtwoord dat Google genereert en plak het hieronder",
    "passwordSecurity": "Merkflow slaat het wachtwoord versleuteld op. We loggen het nooit en sturen het ook niet terug naar je browser.",
    "yourEmail": "Je e-mailadres",
    "emailExample": "jij@bedrijf.com",
    "appPassword": "App-wachtwoord",
    "keepCurrent": "(leeg laten om huidige te behouden)",
    "passwordMask": "••••••••••••••••",
    "passwordPlaceholder": "xxxx xxxx xxxx xxxx",
    "passwordSpaces": "Spaties zijn prima — Google toont het als vier groepen van vier tekens.",
    "fromAddress": "Afzenderadres",
    "fromAddressDefault": "Standaard gelijk aan e-mail",
    "fromName": "Afzendernaam",
    "fromNameExample": "Acme Marketing",
    "advancedSmtp": "Geavanceerd — SMTP host & poort",
    "host": "Host",
    "port": "Poort",
    "smtpDefaults": "Standaard: smtp.gmail.com:587 (STARTTLS). Overschrijf voor Microsoft 365 (smtp.office365.com:587) of een andere provider.",
    "testSuccess": "SMTP-verbinding succesvol — gegevens zijn geldig.",
    "testFailed": "Verbinding mislukt.",
    "testConnection": "Verbinding testen",
    "appPasswordRequired": "App-wachtwoord is verplicht",
    "emailRequired": "E-mailadres is verplicht",
    "membersDescription": "Nodig teamleden uit en beheer hun toegang tot deze werkruimte.",
    "teamMembers": "Teamleden",
    "noMembers": "Nog geen leden",
    "inviteFirstTeammate": "Nodig je eerste teamlid uit om samen te werken.",
    "removeConfirm": "{{name}} verwijderen uit deze werkruimte?",
    "noPendingInvitations": "Geen openstaande uitnodigingen",
    "pendingInviteDescription": "Zodra je iemand uitnodigt, verschijnt hun status hier tot ze accepteren.",
    "inviteExpires": "Verloopt {{date}}",
    "revokeInvitation": "Uitnodiging intrekken",
    "revokeConfirm": "Uitnodiging voor {{email}} intrekken?",
    "inviteTeammate": "Nodig een teamlid uit",
    "inviteSubtitle": "Verstuur een uitnodiging via e-mail.",
    "emailPlaceholder": "teamlid@bedrijf.com",
    "role": "Rol",
    "memberDescription": "Kan content aanmaken, bewerken en reageren.",
    "approverDescription": "Rechten van een lid plus posts goedkeuren / afwijzen.",
    "adminDescription": "Rechten van een goedkeurder plus facturatie & verbindingen.",
    "ownerPromotionNote": "Alleen bestaande eigenaren kunnen iemand promoveren tot EIGENAAR, en alleen nadat ze de uitnodiging hebben geaccepteerd.",
    "sendInvitation": "Uitnodiging versturen",
    "planLimit": "Je hebt de teamlimiet van je abonnement bereikt. Upgrade om meer mensen uit te nodigen.",
    "alreadyMember": "Deze persoon is al lid van deze werkruimte.",
    "inviteFailed": "Uitnodigen mislukt (HTTP {{status}})",
    "privacy": "Privacy & gegevens",
    "privacyDescription": "Je AVG-rechten — export, bewaring en accountverwijdering",
    "deletionScheduled": "Accountverwijdering ingepland",
    "deletionScheduledDesc": "Je account wordt permanent verwijderd op {{date}}. Bevestigingscode: {{code}}",
    "cancelDeletion": "Verwijderingsverzoek annuleren →",
    "exportDescription": "Download een volledig JSON-archief van je posts, merken, analyses, verbindingen en accountgegevens — je recht onder AVG Artikel 20 (dataportabiliteit).",
    "exportIncludes": "Bevat: accountinfo · werkruimtes · merken · posts · verbonden platforms · toestemmingsgeschiedenis",
    "exportExcludes": "Uitgesloten: OAuth-tokens, AI-gegenereerde beelden, reel-video's (deze verlopen en kunnen opnieuw gegenereerd worden), en activiteit van anderen op gekoppelde platforms (bijv. reacties en likes van LinkedIn-leden — alleen in de app getoond, nooit geëxporteerd).",
    "preparingExport": "Export voorbereiden…",
    "requestExport": "Export aanvragen",
    "dataRetention": "Gegevensbewaring",
    "dataRetentionDescription": "Hoe lang Merkflow je gegevens bewaart.",
    "dataStorageNote": "Automatische opruiming draait dagelijks. Gegevens worden opgeslagen op EU-infrastructuur (Hetzner, Duitsland).",
    "platformRetentionNote": "Inhoud die we ophalen van gekoppelde platforms (LinkedIn, Meta, X) volgt de kortere bewaartermijnen die die platforms vereisen. Zo worden reacties en likes van LinkedIn-leden op je berichten binnen 48 uur verwijderd, en gesynchroniseerde LinkedIn-paginaberichten binnen 6 maanden. We bewaren de referentie-ID's, maar de inhoud niet langer dan deze termijnen.",
    "deleteAccountDescription": "Verwijder je account permanent met alle bijbehorende gegevens. Je hebt 30 dagen de tijd om dit te annuleren. Daarna worden al je posts, merken, analyses en verbindingen definitief verwijderd.",
    "gdprArticle17": "Dit is je recht onder AVG Artikel 17 (recht op vergetelheid).",
    "deletionScheduledFor": "Verwijdering ingepland voor {{date}}",
    "deletionGracePeriod": "Dit start een periode van 30 dagen",
    "deleteConfirmationText": "Hiermee wordt je account over 30 dagen verwijderd. Alle posts, merken, analyses en verbindingen worden permanent verwijderd. Je kunt dit binnen de 30 dagen nog annuleren.",
    "confirmDeleteAccount": "Ja, verwijder mijn account",
    "cancelDeletionRequest": "Verwijderingsverzoek annuleren",
    "keepAccountActive": "Houd je account actief",
    "cancelDeletionDescription": "Hiermee annuleer je het verwijderingsverzoek en blijft je account actief.",
    "confirmKeepAccount": "Ja, behoud mijn account",
    "retention": {
      "postsLabel": "Posts & inhoud",
      "postsPeriod": "24 maanden na aanmaken",
      "analyticsLabel": "Analysegegevens",
      "analyticsPeriod": "12 maanden",
      "visualsLabel": "Visuele media (afbeeldingen / reels)",
      "visualsPeriod": "90 dagen na verwijderen post",
      "engagementLabel": "Engagement-historie",
      "engagementPeriod": "12 maanden",
      "accountLabel": "Accountgegevens",
      "accountPeriod": "Tot account verwijderd is",
      "auditLabel": "Audit logs",
      "auditPeriod": "6 maanden",
      "backupsLabel": "Back-ups",
      "backupsPeriod": "Binnen 30 dagen na accountverwijdering verwijderd"
    }
  },
  "aiVisibility": {
    "pageTitle": "AI-zichtbaarheid",
    "pageSubtitle": "Hoe {{name}} verschijnt in ChatGPT, Perplexity en Google AI Overviews.",
    "pageSubtitleWorkspace": "Hoe je merken verschijnen in ChatGPT, Perplexity en Google AI Overviews. Kies een merk voor het volledige rapport.",
    "pickBrand": "Kies een merk",
    "pickBrandHint": "Kies hierboven een merk om het volledige AI-zichtbaarheidsrapport te zien.",
    "noBrandsInWorkspace": "Nog geen merken in deze werkruimte. Voeg er eerst een toe via de Merken-pagina.",
    "backToBrand": "Terug naar {{name}}",
    "runProbeNow": "Probe uitvoeren",
    "probeComplete": "Probe klaar — verse resultaten hieronder.",
    "probeStarted": "Probe gestart — draait op de achtergrond. Resultaten verschijnen hieronder zodra ze binnenkomen.",
    "probeRunning": "Probe loopt…",
    "probeAlreadyRunning": "Er loopt al een probe voor dit merk — wacht tot die klaar is.",
    "probeRateLimited": "Al geprobed in het afgelopen uur.",
    "downloadPdf": "PDF downloaden",
    "pdfGenerating": "PDF genereren…",
    "pdfReady": "PDF klaar.",
    "pdfReadyBlocked": "PDF klaar — niet geopend? Klik hier.",
    "pdfOpen": "PDF openen",
    "pdfDismiss": "Sluiten",
    "pdfFailed": "PDF genereren mislukt — probeer het zo opnieuw.",
    "pdfTimeout": "PDF wordt nog gegenereerd — check zo terug.",
    "pdfRateLimited": "Daglimiet PDF bereikt (3/dag).",
    "pdfUpgradeNeeded": "Upgrade naar Agency voor PDF-rapporten.",
    "probeFailed": "Probe mislukt — probeer het zo opnieuw.",
    "probeUpgradeNeeded": "Upgrade naar Pro om probes te draaien.",
    "lastUpdated": "Bijgewerkt {{date}}",
    "section1Title": "Score",
    "section2Title": "Wat nu te doen",
    "section3Title": "AI-zoekprobes",
    "section4Title": "WordPress + llms.txt",
    "section5Title": "Content-gap analyse",
    "section6Title": "Uitleg",
    "outOf100": "van de 100",
    "radarTitle": "Score-componenten",
    "radarMentions": "Vermeldingen",
    "radarAiMentionRate": "AI-vermeldingen",
    "radarPostsPublished": "Posts",
    "radarPlatforms": "Platforms",
    "radarConsistency": "Consistentie",
    "radarDiversity": "Diversiteit",
    "trendTitle": "90-dagen trend",
    "statMentions": "Vermeldingen (30d)",
    "postsPublished": "Gepubliceerde berichten",
    "followers": "Volgers",
    "postsPublishedTooltip": "Berichten gepubliceerd op alle platformen in de afgelopen 30 dagen. Meer berichten = meer signalen voor AI-zoekmachines.",
    "aiMentionRate": "AI-vermeldingspercentage",
    "noProbes": "Nog geen probes",
    "probeCount_one": "uit {{count}} probe",
    "probeCount_other": "uit {{count}} probes",
    "publishedPosts": "Gepubliceerde posts",
    "insufficientData": {
      "title": "Nog niet genoeg data",
      "subtitle": "Publiceer nog een paar posts om je AI-zichtbaarheid te gaan meten — je hebt er nu {{current}}."
    },
    "upgradeForProbes": "Upgrade naar Pro om AI-zoekmonitoring toe te voegen aan je score.",
    "sentiment": {
      "positive": "Positief vermeld",
      "neutral": "Neutraal vermeld",
      "negative": "Negatief vermeld",
      "not_mentioned": "Niet gevonden"
    },
    "confidence": "zekerheid",
    "citations": {
      "title": "Citaten",
      "empty": "Nog geen citaten — verschijnen na de volgende probe.",
      "brandCitedTitle": "Jouw URL's geciteerd door AI-zoekmachines (laatste 30 dagen)",
      "gap": "Citatiehiaten",
      "noGaps": "Geen concurrentiehiaten gedetecteerd — blijf publiceren om voorop te blijven.",
      "competitorsCited": "Concurrenten geciteerd: {{domains}}",
      "generateBlog": "Genereer blogpost om dit hiaat te dichten →",
      "generating": "Concept aan het genereren…",
      "blogGenerated": "Citatiehiaat-blogconcept staat klaar in je Blog-tab.",
      "blogGenerateFailed": "Kon blogconcept niet genereren. Probeer het over een minuut opnieuw.",
      "verified": "Nu geciteerd door AI-zoekmachines!"
    },
    "score": {
      "mentionRate": "Vermeldingspercentage",
      "citationRate": "Citatiepercentage",
      "engineCoverage": "Zoekmachinedekking",
      "sentiment": "Sentiment",
      "competitorDelta": "vs concurrenten",
      "v2Note": "Score v2 — gebaseerd op werkelijke AI-vermeldingen"
    },
    "engine": {
      "claude": "Claude",
      "perplexity": "Perplexity",
      "gemini": "Google AI"
    },
    "competitors": {
      "title": "Concurrenten",
      "add": "Concurrent toevoegen",
      "limit": "{{count}}/{{max}} concurrenten",
      "remove": "Verwijderen",
      "removeConfirm": "Deze concurrent verwijderen? De probegeschiedenis blijft bewaard.",
      "shareOfVoice": "Aandeel in zichtbaarheid (laatste 30 dagen)",
      "mentionRate": "{{pct}}% vermeld",
      "topCited": "Meest geciteerde bronnen",
      "sentimentBreakdown": "Sentimentverdeling",
      "upgrade": "Vergelijk je merk met concurrenten. Beschikbaar vanaf Pro.",
      "youLabel": "Jij",
      "duplicate": "Een concurrent met deze naam is al actief voor dit merk.",
      "nameLabel": "Naam concurrent",
      "namePlaceholder": "bijv. Concurrent BV",
      "urlLabel": "Website (optioneel)",
      "empty": "Nog geen probegegevens — wordt elke maandag gedraaid, of klik op \"Nu proben\"."
    },
    "claudeMonthlyNote": "Claude-probes draaien maandelijks (laatst: {{date}}). Gebruik \"Nu proben\" om alle engines direct te controleren.",
    "recs": {
      "lowMentionCount": {
        "title": "Publicatieritme te laag",
        "body": "Je publiceerde {{count}} berichten in de afgelopen 30 dagen. AI-zoekmachines koppelen merken aan wat vaak en recent verschijnt — consistentie wint van losse uitbarstingen.",
        "action": "Cadans openen"
      },
      "narrowPlatformSpread": {
        "title": "Te weinig platformen actief",
        "body": "Je bent verbonden met {{count}} platformen. Spreiding over LinkedIn, Instagram en een derde kanaal zorgt dat AI-engines je als multi-platform merk zien.",
        "action": "Platform verbinden"
      },
      "lowConsistency": {
        "title": "In bursts gepost, niet wekelijks",
        "body": "Consistentie staat op {{pct}}%. Wekelijks ritme wint van losse bursts — AI-modellen pikken recency + herhaling op.",
        "action": "Cadans bekijken"
      },
      "lowDiversity": {
        "title": "Contentmix te smal",
        "body": "Contenttypediversiteit staat op {{pct}}%. Mix educatieve, social-proof- en thought-leadershipberichten om AI te leren waar je over gaat — niet alleen hoe vaak je post.",
        "action": "Mix plannen"
      },
      "categoryProbeMiss": {
        "title": "AI-zoekmachines koppelen je niet aan je categorie",
        "body": "{{count}} van {{total}} categoriequery's vermeldden je niet. Schrijf een blogpost die definieert in welke categorie je actief bent.",
        "action": "Blogconcept genereren"
      },
      "liveWebOnly": {
        "title": "Wel zichtbaar in live web, nog niet in AI-trainingsdata",
        "body": "Perplexity en Gemini vinden je {{count}}× via live-zoeken, maar Claude nog niet. Dat haalt zichzelf doorgaans binnen ~6 maanden in als content zich verspreidt — blijf publiceren."
      },
      "noWordpressConnection": {
        "title": "Blogposts hebben geen plek zonder WordPress",
        "body": "We kunnen alleen blogconcepten + llms.txt publiceren als er een WordPress-site verbonden is. Twee minuten met een Application Password en je bent klaar.",
        "action": "WordPress verbinden"
      },
      "noRecentBlogDrafts": {
        "title": "Geen blogconcepten in 30 dagen",
        "body": "De wekelijkse blogtaak kan gepauzeerd zijn of de planlimiet is bereikt. Even checken loont — één goed geïndexeerde post per week werkt cumulatief voor AI-zichtbaarheid.",
        "action": "Blog openen"
      },
      "staleLlmsTxt": {
        "title": "Je llms.txt is verouderd",
        "body": "Je llms.txt is langer dan {{days}} dagen niet bijgewerkt. Een nieuwe push laat AI-crawlers weten dat je actief bent.",
        "action": "llms.txt opnieuw publiceren"
      }
    },
    "statPlatforms": "Platforms",
    "statConsistency": "Consistentie",
    "statDiversity": "Diversiteit",
    "noScoreYet": "Kom terug na je eerste week — we hebben wat posts nodig om je te scoren.",
    "allGoodTitle": "Sterke AI-zichtbaarheid",
    "allGoodBody": "Geen urgente acties. Blijf wekelijks posten om het vol te houden.",
    "probeTab_overview": "Overzicht",
    "probeTab_byEngine": "Per engine",
    "probeTab_queries": "Queries",
    "noProbesYet": "Nog geen probe-resultaten. Voer er nu een uit of wacht op maandag.",
    "qt_direct": "Direct",
    "qt_category": "Categorie",
    "qt_problem": "Probleem",
    "qt_custom": "Eigen",
    "probeMentioned": "Vermeld",
    "probeNotMentioned": "Niet vermeld",
    "viewResponse": "Toon antwoord",
    "enginePassRate": "{{pct}}% — {{mentions}} van {{probes}} probes vermeldden je",
    "engineNegatives": "{{count}} negatieve/onzekere vermeldingen",
    "queriesDefaultsTitle": "Standaard queries",
    "queriesRegenerate": "Alles regenereren",
    "regenCounter": "{{count}} / {{limit}} vandaag",
    "regenDailyLimit": "Daglimiet bereikt — probeer morgen opnieuw",
    "queriesCustomTitle": "Eigen queries",
    "queriesCustomEmpty": "Nog geen eigen queries. Voeg er een toe op de merk-detailpagina.",
    "wpNotConnectedTitle": "Verbind WordPress om blogposts te publiceren",
    "wpNotConnectedBody": "Zonder WordPress blijven blogdrafts verborgen en kan llms.txt niet worden gepubliceerd. Twee minuten met een App Password.",
    "wpGoConnect": "WordPress verbinden",
    "wpRepublishSuccess": "Gepubliceerd — {{bytes}} bytes naar je site.",
    "wpRepublishFailed": "Opnieuw publiceren mislukt",
    "wpRepublishNeedsPlugin": "llms.txt vereist de Merkflow-plugin",
    "wpRepublishNeedsPluginHint": "Opnieuw publiceren werkt alleen als dit merk verbonden is via de Merkflow-plugin. Verbreek en verbind opnieuw via Plugin om dit te activeren.",
    "wpApiKeyLlmsHint": "llms.txt vereist de Merkflow-plugin. Verbreek en verbind opnieuw via plugin om hem te activeren.",
    "wpPluginLlmsUrl": "Beschikbaar op",
    "wpConnectedTitle": "WordPress verbonden",
    "wpLastVerified": "Laatst geverifieerd {{date}}",
    "wpRepublish": "llms.txt opnieuw publiceren",
    "wpRecentDrafts": "Recente blog-drafts",
    "wpNoDrafts": "Nog geen drafts — de wekelijkse job draait maandag 07:00.",
    "wpManageAll": "Alle drafts beheren",
    "section5Hint": "Posts per content-type in de laatste 30 dagen — stippellijn is het aanbevolen minimum.",
    "ctCount": "{{count}} / min {{min}}",
    "ctGenerateOfType": "Genereer een {{type}}-post",
    "ct_EDUCATIONAL": "Educatief",
    "ct_SOCIAL_PROOF": "Social proof",
    "ct_THOUGHT_LEADERSHIP": "Thought leadership",
    "ct_PRODUCT_HIGHLIGHT": "Product highlight",
    "ct_INDUSTRY_REACTION": "Industrie-reactie",
    "ct_BEHIND_THE_SCENES": "Behind the scenes",
    "learnQ1": "Wat is een GEO Score?",
    "learnA1": "Een score van 0–100 die meet hoe consistent jouw merk verschijnt op social platforms. AI-zoekmachines leren wie er toe doet in een categorie door vermeldingen op het hele web te zien. Hoe vaker en consistenter je publiceert, hoe meer ze jou met jouw vakgebied associëren.",
    "learnQ2": "Wat doet de probe?",
    "learnA2": "Elke maandag stuurt Merkflow 3 vragen over jouw categorie naar Claude, Perplexity en Gemini — zonder jouw merknaam in de vraag. We checken of een van de engines jou noemt in het antwoord. Dat is een direct signaal of AI-zoek jou al kent.",
    "learnQ3": "Hoe verbeter ik mijn score?",
    "learnA3": "Publiceer consistent (wekelijks wint van bursts), verspreid over platforms (minimaal LinkedIn + Instagram), dek meerdere content-types af (thought leadership + educatief tellen zwaarder), en publiceer naar een blog met een publieke llms.txt zodat AI-crawlers je direct kunnen indexeren.",
    "learnQ4": "Wat is llms.txt?",
    "learnA4": "Een simpel tekstbestand aan de root van je website dat AI-crawlers vertelt wie je bent en waar je over gaat — het AI-equivalent van robots.txt. Merkflow genereert en publiceert die automatisch als je WordPress verbindt.",
    "citability": {
      "title": "GEO-score",
      "good": "GEO ✓",
      "improvable": "GEO ↑",
      "low": "GEO ↓",
      "rescore": "Opnieuw scoren",
      "brandClarity": "Merknaamhelderheid",
      "factualDensity": "Feitelijke dichtheid",
      "keywordRelevance": "Zoekwoordrelevantie",
      "answerPotential": "Antwoordpotentieel",
      "entityReinforcement": "Entiteitsversterking",
      "suggestions": "Suggesties",
      "improve": "Verbeter met AI",
      "improving": "Herschrijven…",
      "improveHint": "Laat de AI opnieuw schrijven met deze suggesties als richtlijn. Kost ongeveer €0.02–0.03 per klik, afhankelijk van het AI-model van je plan.",
      "improveError": "Verbeteren mislukt. De post is mogelijk al gepubliceerd of je hebt de 5/uur-limiet bereikt (gedeeld met herwaarderen)."
    },
    "correlation": {
      "title": "Publicatie-impact",
      "period": "Afgelopen {{days}} dagen",
      "postsAxis": "Gepubliceerde berichten",
      "scoreAxis": "GEO-score",
      "positiveCorrelation": "Weken met {{count}}+ berichten hadden {{pct}}% hogere AI-vermeldingen.",
      "contentTypeSignal": "Je '{{type}}'-berichten correleren met de sterkste probeverbeteringen.",
      "platformSignal": "{{platform}}-berichten dragen het meest bij aan je AI-zichtbaarheid — AI-engines citeren dit netwerk vaak.",
      "consistencySignal": "Consequent wekelijks publiceren heeft je GEO-score verbeterd.",
      "inactivityWarning": "Geen berichten voor {{weeks}} weken — je GEO-score daalde {{delta}} punten."
    },
    "gapPost": {
      "generate": "Genereer bericht om dit op te lossen",
      "generating": "Bezig met genereren…",
      "success": "Concept aangemaakt — bekijk het in je inbox.",
      "failed": "Kon het bericht niet genereren — probeer het zo opnieuw.",
      "alreadyMentioned": "Probe noemt het merk al — geen hiaat om op te lossen."
    },
    "naming": {
      "title": "Merknaamconsistentie",
      "consistent": "{{pct}}% van je berichten gebruikt je exacte merknaam.",
      "tip": "Gebruik \"{{name}}\" consequent in elk bericht. AI-zoekmachines zien naamvariaties als verschillende entiteiten."
    },
    "customProbeRunNow": "Run deze probe nu",
    "customProbeRan": "Probe gedraaid — vers resultaat hieronder.",
    "customProbeRunFailed": "Kon de probe niet draaien — probeer het zo opnieuw.",
    "customProbeRateLimit": "Rate-limit bereikt — probeer het over een paar minuten.",
    "customProbeRemoved": "Aangepaste probe verwijderd.",
    "customProbeRemoveFailed": "Kon de probe niet verwijderen — probeer het opnieuw.",
    "customProbeRemoveConfirm": "Deze aangepaste probe verwijderen? Eerdere resultaten blijven in je historie.",
    "customProbeAdded": "Aangepaste probe toegevoegd — draait in de volgende cyclus.",
    "customProbeAddFailed": "Kon de probe niet toevoegen — probeer het opnieuw.",
    "customProbeAdd": "Probe toevoegen",
    "customProbePlaceholder": "Typ een vraag voor AI-engines (8–200 tekens)…",
    "doubleClickToEdit": "Dubbelklik om te bewerken",
    "keywords": {
      "title": "Onderwerpsdekking",
      "reinforced": "Versterkt",
      "gaps": "Hiaten",
      "untested": "Niet getest",
      "addProbe": "Toevoegen als probe",
      "minPosts": "Publiceer meer berichten om onderwerpsdekking te zien ({{count}} / {{min}} gescoord).",
      "probeAdded": "Probe toegevoegd — draait mee in de volgende cyclus.",
      "probeAddFailed": "Kon de probe niet toevoegen — probeer het opnieuw."
    }
  },
  "brands": {
    "carouselTemplate": {
      "title": "Carousel-sjabloon",
      "subtitle": "Kies hoe elke LinkedIn carousel van dit merk eruit ziet. Je kunt later wisselen.",
      "systemBadge": "Standaard",
      "create": "Maak nieuw sjabloon",
      "createSubtitle": "Ontwerp je eigen variant",
      "proGate": "Eigen ontwerpen op Pro",
      "proGateSubtitle": "Upgrade naar Pro om eigen sjablonen te maken.",
      "brandColor": "Accentkleur",
      "brandColorHint": "Overschrijft de standaardkleur van het sjabloon. Laat leeg om de sjabloonkleur te gebruiken."
    },
    "title": "Merken",
    "subtitle": "Elk merk dat je in je werkruimte beheert.",
    "addBrand": "Nieuw merk",
    "competitors": {
      "title": "Concurrenten",
      "add": "Toevoegen",
      "remove": "Verwijderen",
      "empty": "Nog geen concurrenten toegevoegd.",
      "counter": "{{count}}/{{max}} concurrenten",
      "upgrade": "Vergelijk AI-zichtbaarheid met concurrenten. Beschikbaar op Pro."
    },
    "noBrands": "Nog geen merken. Voeg je eerste merk toe.",
    "brandName": "Merknaam",
    "website": "Website",
    "description": "Omschrijving",
    "postsThisMonth": "Posts deze maand",
    "postsTotal": "posts totaal",
    "noPostsYet": "Nog geen posts",
    "crawlWebsite": "Website crawlen",
    "reCrawl": "Opnieuw crawlen",
    "crawlNow": "Nu crawlen",
    "crawling": "Crawlen...",
    "crawlComplete": "Crawl voltooid",
    "crawlFailed": "Crawl mislukt",
    "notYetCrawled": "Nog niet gecrawld",
    "websiteNotAnalyzed": "Website nog niet geanalyseerd.",
    "whatYouToldUs": "Wat je ons vertelde",
    "whatWeLearned": "Wat we hebben geleerd",
    "setupProfile": "Merkprofiel instellen",
    "noProfile": "Nog geen merkprofiel.",
    "whatYouDo": "Wat doe je?",
    "idealCustomer": "Ideale klant",
    "tone": "Tone of voice",
    "postVoice": "Stem van de post",
    "language": "Taal",
    "deleteBrand": "Merk verwijderen",
    "deleteConfirmTitle": "{{name}} verwijderen?",
    "deleteConfirmMessage": "Alle posts, analytics, GEO-scores, blogconcepten en engagement-items voor dit merk worden permanent verwijderd. Dit kan niet ongedaan gemaakt worden.",
    "addBrandBtn": "Merk toevoegen",
    "emptyTitle": "Voeg een merk toe en Merkflow leert wat het doet.",
    "emptyDescription": "Plak de URL, beantwoord een paar vragen, en Merkflow doet de rest.",
    "placeholderName": "Mijn merk",
    "placeholderWebsite": "https://voorbeeld.nl",
    "placeholderDescription": "Wat doet dit merk?",
    "identityTitle": "Merkidentiteit",
    "logoDark": "Donker logo",
    "logoLight": "Licht logo",
    "logoDarkHint": "Voor lichte achtergronden",
    "logoLightHint": "Voor donkere achtergronden + reels",
    "uploadLogo": "Upload {{variant}}",
    "deleteConfirm": "Merk \"{{name}}\" verwijderen? Alle posts worden ook verwijderd.",
    "noWebsite": "Geen website",
    "crawledTime": "Gecrawld {{time}}",
    "notFound": "Merk niet gevonden",
    "notFoundDescription": "Dit merk is mogelijk net verwijderd, of de link verwijst naar een andere workspace.",
    "postsTitle": "Posts van dit merk",
    "postsSubtitle": "Elke post die gepland of gepubliceerd is voor dit merk.",
    "showRemoved": "Verwijderde tonen",
    "tellUsAbout": "Vertel ons over {{brandName}}",
    "onboardingHint": "Help de AI je merk te begrijpen. Alle velden zijn optioneel.",
    "whatYouDoExample": "We bouwen duurzame verpakkingen voor e-commerce merken",
    "idealCustomerExample": "DTC-merken met 1M+ omzet die duurzamer willen worden",
    "recentWins": "Recente successen of projecten",
    "winPlaceholder": "Win of project #{{index}}",
    "voiceBrand": "Als merk (wij)",
    "voiceFounder": "Als oprichter (ik / mij)",
    "founderNamePlaceholder": "Naam van oprichter (gebruikt bij het afsluiten van posts)",
    "founderVoiceNote": "Oprichtersstem krijgt 5× meer LinkedIn-bereik dan merkstem.",
    "extraContext": "Iets anders dat de AI moet weten?",
    "extraContextExample": "Noem concurrent X nooit, sluit altijd af met een vraag",
    "saveAndCrawl": "Opslaan en crawlen",
    "aiVisibility": "AI-zichtbaarheid",
    "aiVisibilityOverviewTitle": "AI-zichtbaarheid overzicht",
    "aiVisibilityOverviewSubtitle": "Hoe jouw merk verschijnt in AI-zoekmachines.",
    "seeFullReport": "Volledig rapport",
    "topRecommendations": "Top aanbevelingen",
    "aiVisibilityAllGood": "Sterke AI-zichtbaarheid. Blijf wekelijks posten om dat vol te houden.",
    "aiVisibilityScore": "AI-zichtbaarheidsscore",
    "aiVisibilityEmpty": "Nog niet genoeg gegevens. Publiceer minimaal 3 posts om je AI-zichtbaarheidsscore te zien. De score wordt 's nachts bijgewerkt.",
    "aiVisibilityTooltip": "{{score}}/100 — {{mentions}} vermeldingen op {{platforms}} platforms ({{days}}d)",
    "mentions": "Merkvermeldingen",
    "platformSpread": "Platformspreiding",
    "platformsActive": "platforms actief",
    "consistency": "Consistentie",
    "weeksActive": "weken met posts",
    "scoreTrend": "Scoretrend — laatste 90 dagen",
    "probeDetails": "Probe-details",
    "probeExplain": "We stellen AI-engines deze vragen om te zien of je merk in hun antwoorden verschijnt.",
    "queriesTested": "Queries getest",
    "lastProbed": "laatst getest {{date}}",
    "positiveMentions": "Positieve vermeldingen",
    "aiRecommends": "AI beveelt je merk aan",
    "negativeMentions": "Negatieve vermeldingen",
    "aiUnsure": "AI kent je maar zegt \"niet zeker\"",
    "notMentioned": "Merk wordt helemaal niet genoemd",
    "improvementTips": "Hoe je je score verbetert",
    "tipMorePosts": "Publiceer meer posts — streef naar 20+ per maand ({{current}}/20 deze periode)",
    "tipMorePlatforms": "Verbind meer platforms — je post op {{current}}/4 actieve platforms",
    "tipConsistentCadence": "Houd je cadans consistent — keur wekelijks posts goed, niet in batches",
    "tipMixContent": "Mix contenttypes — thought leadership en educatieve posts tellen extra mee",
    "successMessage": "Sterke AI-zichtbaarheid — je merk verschijnt consistent op alle platforms",
    "probeSettings": "AI-probe-instellingen",
    "probeSettingsHint": "Bepaalt hoe Perplexity naar je merk zoekt",
    "country": "Land",
    "autoDetect": "Automatisch",
    "searchLanguage": "Zoektaal",
    "searchRecency": "Zoekperiode",
    "recencyDefault": "Standaard (maand)",
    "recencyDay": "Laatste 24 uur",
    "recencyWeek": "Afgelopen week",
    "recencyMonth": "Afgelopen maand",
    "recencyYear": "Afgelopen jaar",
    "probeAllTypes": "Alle types",
    "probeDirect": "Merkzoekactie",
    "probeCategory": "Categoriezoekactie",
    "probeProblem": "Probleemzoekactie",
    "probeCustom": "Aangepast",
    "probeAnyResult": "Elk resultaat",
    "probePositive": "Positief",
    "probeNegative": "Negatief",
    "probeNotFoundOpt": "Niet gevonden",
    "probeAllEngines": "Alle engines",
    "probeSearchPlaceholder": "Zoek querytekst of AI-antwoord…",
    "probeClear": "Wissen",
    "probeResultCount_one": "{{filtered}} van {{total}} resultaat",
    "probeResultCount_other": "{{filtered}} van {{total}} resultaten",
    "probeNoMatches": "Geen probe-resultaten voor de huidige filters.",
    "probePage": "Pagina {{current}} van {{total}}",
    "probePrev": "Vorige pagina",
    "probeNext": "Volgende pagina",
    "engineClaudeFull": "Claude AI (trainingsdata)",
    "enginePerplexityFull": "Perplexity (live web)",
    "viaEngine": "via {{engine}}",
    "probeNegativeBadge": "Negatieve vermelding",
    "probeExcerpt": "AI-antwoord fragment",
    "probeFullAnswer": "Volledige antwoord tonen",
    "defaultProbesTitle": "Standaard probes",
    "defaultProbesHint": "Automatisch gegenereerd uit je merkprofiel: een directe naam-zoekopdracht, een categorievraag en een probleemgerichte vraag. Zet uit om een type bij de volgende run over te slaan; regenereer om de tekst te verversen.",
    "defaultProbesRegenerate": "Opnieuw genereren",
    "defaultProbesEmpty": "Nog geen standaard probes — bij de volgende geplande run worden ze gegenereerd.",
    "probeNegativeExcerpt": "AI noemde je negatief",
    "tipDirectNotFound": "Claude kent je merk nog niet bij naam. Vergroot je online aanwezigheid en publiceer meer content.",
    "tipCategoryNotFound": "Je merk stond niet tussen de categorieleiders. Publiceer meer thought leadership content.",
    "tipCustomNotFound": "Niet genoemd bij deze query. Blijf relevante content publiceren.",
    "tipProblemNotFound": "Je merk kwam niet naar voren als oplossing. Publiceer content die dit probleem direct aanpakt.",
    "customProbes": "Aangepaste probes",
    "customProbesHint": "Voeg je eigen vragen toe om te testen wat AI-engines over je merk zeggen. Deze draaien elke maandag mee met de auto-gegenereerde probes.",
    "runProbeTitle": "Draai deze probe nu",
    "deleteProbeTitle": "Probe verwijderen",
    "customProbePlaceholder": "bijv. Wat zijn de beste social media management tools?",
    "backToBrands": "Terug naar merken",
    "totalReach": "Totaal bereik",
    "engagements": "Interacties",
    "pendingReview": "Wacht op review",
    "voiceFounderWithName": "Oprichter — {{name}}",
    "voiceFounderPersonal": "persoonlijk",
    "voiceBrandShort": "Merk",
    "languageDutchFlag": "🇳🇱 Nederlands",
    "languageEnglishFlag": "🇬🇧 English",
    "languageBothFlag": "🌐 Beide",
    "updatedTime": "Bijgewerkt {{time}}",
    "targetAudience": "Doelgroep",
    "valueProposition": "Waardepropositie",
    "brandVoice": "Merkstem",
    "productsServices": "Producten / diensten",
    "keyMessages": "Kernboodschappen",
    "socialProof": "Social proof",
    "recentPosts": "Recente posts",
    "viewAllArrow": "Alles bekijken →",
    "noPostsDescription": "Genereer de eerste AI-posts voor dit merk.",
    "learnedFromPosts": "Wat we leerden van je posts",
    "requiresApproval": {
      "label": "Goedkeuring vereist voor publicatie",
      "description": "Gegenereerde posts wachten in PENDING en triggeren een goedkeuringsmelding per e-mail. Standaard uit — drafts worden automatisch goedgekeurd en gaan direct in de planning."
    },
    "voiceMaturity": {
      "title": "Merkstem",
      "subtitle": "Hoe goed Merkflow je stem kent",
      "postDepth": "Postdiepte",
      "themes": "Thema's geleerd",
      "style": "Stijl geleerd",
      "topics": "Onderwerpbreedte",
      "quality": "Contentkwaliteit",
      "publishMore_one": "Publiceer nog {{count}} post om je stemprofiel te versterken.",
      "publishMore_other": "Publiceer nog {{count}} posts om je stemprofiel te versterken.",
      "fullyLearned": "Merkflow kent je stem goed.",
      "insufficient_one": "Publiceer nog {{count}} post om je stem te leren kennen. Je hebt er nu {{current}}.",
      "insufficient_other": "Publiceer nog {{count}} posts om je stem te leren kennen. Je hebt er nu {{current}}."
    },
    "noPostMemory": "Nog geen post-geheugen. Zodra een merk wat gepubliceerde posts heeft, vat Merkflow hier de terugkerende thema's en tone of voice samen.",
    "postsAnalysed_one": "{{count}} post geanalyseerd",
    "postsAnalysed_other": "{{count}} posts geanalyseerd",
    "recurringThemes": "Terugkerende thema's",
    "howPostsSound": "Hoe je posts klinken",
    "topTopics": "Top onderwerpen",
    "aiCadence": "AI-cadans",
    "editArrow": "Bewerken →",
    "noCadenceConfigured": "Geen cadans ingesteld",
    "onTrack": "Op schema",
    "needsAttention": "Aandacht nodig",
    "cadenceSummary_one": "{{posts}} posts / week op {{count}} platform",
    "cadenceSummary_other": "{{posts}} posts / week op {{count}} platformen",
    "noPlatformsScheduled": "Geen platformen gepland",
    "cadenceRow": "{{count}}× / week · {{time}}",
    "defaultPostingAccounts": "Standaard postaccounts",
    "defaultPostingHint": "Posts die voor dit merk worden gegenereerd, worden standaard vanaf deze accounts gepubliceerd. Per post kun je dit in de reviewinbox wijzigen.",
    "noSocialAccountsYet": "Nog geen social accounts gekoppeld.",
    "connectAccountArrow": "Account koppelen →",
    "defaultAccountFor": "Standaardaccount voor {{platform}}",
    "notSet": "Niet ingesteld",
    "tonePreset_professional": "Professioneel",
    "tonePreset_playful": "Speels",
    "tonePreset_direct": "Direct",
    "tonePreset_technical": "Technisch",
    "tonePreset_inspiring": "Inspirerend",
    "tonePreset_no_corporate_fluff": "Geen corporate geneuzel",
    "tonePreset_data_driven": "Data-gedreven",
    "tonePreset_conversational": "Informeel",
    "tonePreset_bold": "Gedurfd",
    "languageNameDutch": "Nederlands",
    "languageNameEnglish": "English",
    "languageNameBoth": "Beide",
    "nameRequired": "Naam is verplicht",
    "mustBeValidUrl": "Moet een geldige URL zijn",
    "crawlSocialProfile": "Social profiel",
    "crawlNeedsConnectionBadge": "Account koppelen",
    "crawlSkippedSocial": "Dit lijkt een social profiel, geen website. We bouwen je merkprofiel op uit je eigen posts.",
    "crawlNeedsConnection": "Koppel een social account, dan leren we je stem en thema's uit je echte posts.",
    "crawlLearningBadge": "Leren uit posts",
    "crawlLearning": "Je account is gekoppeld — bij de volgende sync leren we je stem en thema's uit je echte posts."
  },
  "carouselTemplatesPage": {
    "title": "Carrousel-templates",
    "subtitle": "Ontwerp hoe je LinkedIn-carrousels eruitzien. Templates worden per merk toegewezen.",
    "assignments": "Merk-toewijzingen",
    "colBrand": "Merk",
    "colTemplate": "Template",
    "colAccent": "Accentkleur",
    "useDefault": "Standaard ({{name}})",
    "accentPlaceholder": "#e8540a",
    "noBrands": "Nog geen merken in deze workspace.",
    "assignmentSaved": "Opgeslagen",
    "assignmentSaveFailed": "Toewijzing opslaan mislukt",
    "yourTemplates": "Jouw templates",
    "systemTemplates": "Systeemtemplates",
    "systemSubtitle": "Drie beproefde ontwerpen die je direct kunt gebruiken of dupliceren om aan te passen.",
    "systemBadge": "Systeem",
    "createNew": "Nieuwe maken",
    "duplicate": "Dupliceren",
    "noCustom": "Nog geen eigen templates. Dupliceer hieronder een systeemtemplate of klik op \"Nieuwe maken\" om te starten.",
    "copyName": "Templatekopie",
    "duplicateFailed": "Dupliceren mislukt",
    "deleteTitle": "Template verwijderen",
    "deleteConfirm": "\"{{name}}\" verwijderen? Merken die dit template gebruiken vallen terug op de standaard.",
    "deleted": "Template verwijderd",
    "deleteFailed": "Verwijderen mislukt"
  },
  "carouselDesigner": {
    "untitledName": "Naamloze template",
    "createFailed": "Kon template niet aanmaken",
    "saved": "Template opgeslagen",
    "saveFailed": "Opslaan mislukt",
    "previewFailed": "Voorvertoning mislukt",
    "proGate": "Alleen op Pro / Agency",
    "proGateSubtitle": "De Carousel Design Studio is beschikbaar op Pro en Agency. Upgrade om eigen templates te ontwerpen.",
    "ownerGate": "Alleen workspace-eigenaren",
    "ownerGateSubtitle": "Alleen de workspace-eigenaar kan carrousel-templates ontwerpen of aanpassen. Vraag je workspace-eigenaar om wijzigingen door te voeren, of vraag eigenaarstoegang aan.",
    "downloadPdf": "Download PDF",
    "startFromScratch": "Vanaf nul beginnen",
    "startFromScratchHint": "Kies een thema; wij regelen de typografie, spacing en hiërarchie voor je.",
    "section": {
      "theme": "Thema",
      "fonts": "Typografie",
      "color": "Accentkleur",
      "background": "Achtergrond"
    },
    "bg": {
      "light": "Licht",
      "dark": "Donker"
    },
    "slot": {
      "title": "Titel",
      "titleHint": "{{TITLE}} wordt bij het genereren vervangen door het onderwerp van de post.",
      "subtitle": "Subtitel",
      "badge": "Badge",
      "headline": "Kop",
      "body": "Tekst",
      "cta": "Knoptekst",
      "footer": "Voettekst",
      "placeholderHint": "Tokens zoals {{TITLE}}, {{BODY}}, {{CTA_TEXT}} worden vervangen door de AI bij het maken van een echte post. Gebruik ze zodat deze template zich aanpast aan elk stuk content."
    },
    "chooseStart": "Kies een startpunt",
    "chooseStartSubtitle": "Start vanaf een systeemtemplate of dupliceer er één die je al hebt opgeslagen.",
    "preview": "Voorvertoning",
    "elements": "Elementen",
    "slideType": "Slidetype",
    "noSelection": "Klik op een element om de eigenschappen te bewerken.",
    "position": "Positie",
    "element": {
      "text": "Tekst",
      "shape": "Vorm",
      "logo": "Logo",
      "divider": "Lijn",
      "swipe": "Swipe-hint",
      "counter": "Teller",
      "button": "Knop"
    },
    "slide": {
      "cover": "Cover",
      "content": "Inhoud",
      "cta": "Afsluiter"
    },
    "field": {
      "x": "x",
      "y": "y",
      "width": "breedte",
      "height": "hoogte",
      "fontSize": "tekstgrootte",
      "fontWeight": "tekstgewicht",
      "color": "kleur",
      "align": "uitlijning",
      "shapeType": "type",
      "fill": "vulkleur",
      "borderRadius": "afronding",
      "opacityPct": "transparantie %",
      "variant": "variant",
      "maxWidth": "max breedte",
      "maxHeight": "max hoogte",
      "direction": "richting",
      "thickness": "dikte",
      "bgColor": "achtergrond",
      "textColor": "tekstkleur"
    },
    "align": {
      "left": "links",
      "center": "midden",
      "right": "rechts"
    },
    "shape": {
      "rect": "rechthoek",
      "circle": "cirkel",
      "line": "lijn"
    },
    "variant": {
      "dark": "donker (voor lichte achtergrond)",
      "light": "licht (voor donkere achtergrond)"
    },
    "direction": {
      "horizontal": "horizontaal",
      "vertical": "verticaal"
    }
  },
  "review": {
    "title": "Beoordelen",
    "subtitle": "Beheer drafts, goedkeuringen en geplande posts op alle platforms",
    "approve": "Goedkeuren",
    "reject": "Afwijzen",
    "edit": "Bewerken",
    "noPostsPending": "Geen posts in afwachting van beoordeling.",
    "noPendingPosts": "Geen posts in afwachting van beoordeling.",
    "emptyDescription": "Posts verschijnen hier zodra ze gegenereerd zijn. Stel een contentcadans in voor je merken om wekelijks AI-gegenereerde posts te krijgen.",
    "scheduledFor": "Ingepland voor {{date}}",
    "generateMore": "Meer genereren",
    "editPost": "Post bewerken",
    "characters": "tekens",
    "postPreview": "Postvoorbeeld",
    "pendingReview": "Wacht op beoordeling",
    "tabOverview": "overzicht",
    "tabCalendar": "agenda",
    "tabAnalytics": "analyses",
    "contentCalendar": "Contentagenda",
    "allPosts": "Alle posts",
    "allBrands": "Alle merken",
    "allPlatforms": "Alle platforms",
    "standaloneOnly": "Alleen losse",
    "clearFilter": "Filter wissen",
    "sortNewest": "Nieuwste eerst",
    "sortOldest": "Oudste eerst",
    "deleteAll": "Alles verwijderen",
    "deleteAllConfirm_one": "{{count}} post verwijderen? Dit verwijdert de post alleen uit Merkflow en kan niet ongedaan worden gemaakt.",
    "deleteAllConfirm_other": "Alle {{count}} posts verwijderen? Dit verwijdert ze alleen uit Merkflow en kan niet ongedaan worden gemaakt.",
    "deleteAllDone_one": "{{count}} post verwijderd",
    "deleteAllDone_other": "{{count}} posts verwijderd",
    "deleteAllFailed": "Sommige posts konden niet worden verwijderd",
    "scheduleNewPost": "Nieuwe post plannen",
    "recentActivity": "Recente activiteit",
    "latestEngagement": "Laatste engagement",
    "noNewActivity": "Geen nieuwe activiteit",
    "commentsAndMentions": "Reacties en vermeldingen verschijnen hier"
  },
  "posts": {
    "title": "Posts",
    "subtitle": "Elke post in je werkruimte. Filter op merk, platform of status.",
    "generate": "Posts genereren",
    "generateOne": "Post genereren",
    "deleteConfirmPlatform": "Deze post wordt ook verwijderd op {{platform}}. Doorgaan?",
    "deleteConfirmLocal": "Deze post verwijderen? Dit verwijdert hem alleen uit Merkflow.",
    "deleteConfirmInstagram": "Verwijderen hier haalt de post uit Merkflow. Instagram ondersteunt geen programmatische verwijdering — haal hem zelf weg uit de Instagram-app. Doorgaan?",
    "deleteConfirmSyncedIn": "Deze post is direct op {{platform}} geplaatst en gesynchroniseerd naar Merkflow. Verwijderen hier haalt hem alleen uit Merkflow — het origineel blijft op {{platform}} staan tot je hem daar zelf verwijdert. Doorgaan?",
    "generateSubtitle": "AI schrijft platform-geoptimaliseerde drafts die in je beoordelingsinbox belanden",
    "writePost": "Post schrijven",
    "writePostSubtitle": "Handmatige post — slaat de AI-queue over en wordt direct APPROVED",
    "approveAll": "Alles goedkeuren",
    "approveAllPending_one": "{{count}} wachtende post goedkeuren",
    "approveAllPending_other": "Alle {{count}} wachtende posts goedkeuren",
    "approveAllConfirm_one": "{{count}} wachtende post goedkeuren? Hij wordt ingepland om gepubliceerd te worden.",
    "approveAllConfirm_other": "Alle {{count}} wachtende posts goedkeuren? Ze worden ingepland om gepubliceerd te worden.",
    "approveAllDone_one": "{{count}} post goedgekeurd",
    "approveAllDone_other": "{{count}} posts goedgekeurd",
    "import": {
      "button": "CSV importeren",
      "dropzone": "Sleep je CSV-bestand hierheen",
      "dropzoneHint": "Kolommen: platform, content, scheduled_at, brand_id, hashtags",
      "browse": "Bestanden kiezen",
      "downloadTemplate": "Download voorbeeld-CSV",
      "summary": "{{valid}} geldig, {{invalid}} ongeldig van {{total}} rijen",
      "errorsFound": "Sommige rijen hebben fouten en worden overgeslagen:",
      "platform": "Platform",
      "content": "Inhoud",
      "scheduledAt": "Gepland",
      "brand": "Merk",
      "status": "Status",
      "confirm_one": "{{count}} post importeren",
      "confirm_other": "{{count}} posts importeren",
      "importing": "Bezig met importeren…",
      "success_one": "{{count}} post succesvol geïmporteerd",
      "success_other": "{{count}} posts succesvol geïmporteerd",
      "fileTooLarge": "Bestand te groot (max 1MB)",
      "tooManyRows": "Te veel rijen (max 200)",
      "invalidFormat": "Ongeldig CSV-formaat",
      "processing": "Posts worden op de achtergrond geïmporteerd…",
      "canCloseHint": "Je mag dit venster sluiten — de import gaat door.",
      "closeAndKeepRunning": "Sluiten (import gaat door)",
      "failed": "Import mislukt",
      "planLimitFailed_one": "{{count}} rij raakte je maandlimiet voor posts en werd overgeslagen. Koop een top-up of wacht tot de nieuwe maand.",
      "planLimitFailed_other": "{{count}} rijen raakten je maandlimiet voor posts en werden overgeslagen. Koop een top-up of wacht tot de nieuwe maand.",
      "otherFailed_one": "{{count}} rij kon niet worden opgeslagen (zie logs voor details).",
      "otherFailed_other": "{{count}} rijen konden niet worden opgeslagen (zie logs voor details)."
    },
    "published": "Gepubliceerd",
    "draft": "Concept",
    "scheduled": "Ingepland",
    "failed": "Mislukt",
    "pending": "In behandeling",
    "reelFailed": "Reel genereren mislukt",
    "retryReel": "Opnieuw proberen",
    "reelGenerating": "Reel wordt gegenereerd…",
    "reelBadge": "REEL",
    "carouselBadge": "CAROUSEL",
    "linkedinTextPost": "LinkedIn-tekstpost",
    "carouselSlideLabel": "Slide",
    "carouselPrev": "Vorige slide",
    "carouselNext": "Volgende slide",
    "storyBadge": "STORY",
    "storyExpired": "Verlopen",
    "storyArchived": "Gearchiveerd in Merkflow",
    "mediaFormat": {
      "all": "Alles",
      "feed": "Feedbericht",
      "reel": "Reel",
      "story": "Story",
      "carousel": "Carousel"
    },
    "sortOrder": {
      "label": "Sorteervolgorde",
      "newest": "Nieuwste eerst",
      "oldest": "Oudste eerst"
    },
    "hashtagsLabel": "Hashtags ({{count}})",
    "seedLabel": "seed",
    "traceInputs": "in:",
    "traceOutputs": "uit:",
    "retrySuccess": "Opnieuw in de wachtrij — komt binnen een minuut online.",
    "retryFailed": "Opnieuw proberen mislukt — probeer nogmaals of controleer de verbinding.",
    "manualPublish": {
      "title": "Handmatig plaatsen vereist",
      "companyPageReason": "LinkedIn bedrijfspagina’s vereisen de Community Management API. Open LinkedIn en plaats voorlopig handmatig.",
      "failedReason": {
        "manual_only_no_oauth": "Deze verbinding is alleen handmatig (geen OAuth-token). Open LinkedIn en plaats direct vanaf de pagina {{accountName}}.",
        "linkedin_manual_mode": "LinkedIn staat in handmatige plaatsings-modus — geautomatiseerd publiceren is uitgeschakeld. Kopieer de content en plaats handmatig op LinkedIn.",
        "linkedin_company_share_api": "Posten als LinkedIn-bedrijfspagina vereist de Community Management API. Keur handmatig goed, of koppel een persoonlijk profiel aan dit merk.",
        "linkedin_carousel_share_api": "LinkedIn document-carrousels vereisen de Community Management API. Plaats als tekst + afbeelding, of keur handmatig goed na de LinkedIn-upgrade.",
        "linkedin_personal_no_account_id": "Persoonlijke LinkedIn-verbinding mist de account-id — verbind opnieuw om publiceren via de Share-API te activeren.",
        "linkedin_unknown_mode": "Onbekende LinkedIn publish-modus '{{mode}}'. Een beheerder moet de instelling resetten."
      },
      "openLinkedIn": "Openen in LinkedIn",
      "copyText": "Kopieer tekst",
      "copiedShort": "Gekopieerd",
      "copiedToast": "Posttekst gekopieerd naar je klembord.",
      "copyFailed": "Kopiëren mislukt — selecteer de tekst handmatig.",
      "confirmPublished": "Ik heb het geplaatst",
      "confirmedToast": "Post gemarkeerd als geplaatst.",
      "confirmFailed": "Kon niet bevestigen — ververs de pagina en probeer opnieuw.",
      "downloadPdf": "Download carrousel-PDF",
      "downloadImage": "Download afbeelding",
      "downloadVideo": "Download video",
      "attachHint": "Klik na het openen van LinkedIn op + (Document/Foto/Video) in de compose-balk om het gedownloade bestand toe te voegen.",
      "pasteHint": "Tekst staat op je klembord. Plak met ⌘V (of Ctrl+V) in het compose-veld van LinkedIn.",
      "companyAdminHint": "We openen de pagina-admin van {{name}} met het compose-venster klaar. Opent de compose niet automatisch? Klik op \"Start een bericht\" — je post dan al als bedrijf.",
      "companyPublicHint": "We openen de bedrijfspagina van {{name}}. Klik op \"Pagina beheren\" → \"Start een bericht\" om als bedrijf te posten. Plak de tekst van je klembord."
    },
    "republishSuccess": "Opnieuw publiceren gestart — verse kopie komt binnen een minuut online.",
    "republishFailed": "Opnieuw publiceren mislukt — probeer nogmaals of controleer de verbinding.",
    "noPosts": "Nog geen posts.",
    "deletePost": "Post verwijderen",
    "deletePostConfirm": "Weet je zeker dat je deze post wilt verwijderen?",
    "allPlatforms": "Alle platforms",
    "allBrands": "Alle merken",
    "allStatuses": "Alle statussen",
    "viewOnPlatform": "Bekijk op {{platform}}",
    "gridView": "Rasterweergave",
    "tableView": "Tabelweergave",
    "emptyDescription": "Merkflow genereert je eerste posts op maandag. Je kunt ook handmatig posts schrijven via de beoordelingsinbox.",
    "showPending": "Wachtend tonen",
    "showRejected": "Afgewezen tonen",
    "showFailed": "Mislukte tonen",
    "postsCount_one": "{{count}} post",
    "postsCount_other": "{{count}} posts",
    "pageOf": "Pagina {{current}} van {{total}}",
    "removedFromPlatform": "Verwijderd van platform",
    "aboutBrand": "Over",
    "selectBrand": "Kies een merk…",
    "ownBrand": "{{name}} (eigen merk)",
    "crossBrandVoice": "Post gebruikt de stem van {{brandName}} om over {{otherBrandName}} te praten",
    "aiCrossBrandVoice": "AI gebruikt de stem en toon van {{brandName}} om over de producten en inzichten van {{otherBrandName}} te schrijven",
    "platformsSelected_one": "Platforms ({{count}} geselecteerd)",
    "platformsSelected_other": "Platforms ({{count}} geselecteerd)",
    "multiPlatformHint": "Er wordt één post per platform aangemaakt met dezelfde tekst. De tekenlimiet hieronder is de strengste van alle geselecteerde platforms.",
    "platformNotConnected": "{{platform}} is niet gekoppeld aan dit merk. Verbind het in de merkinstellingen om hier te posten.",
    "platformConnectHint": "Sommige platforms zijn niet gekoppeld aan dit merk.",
    "platformConnectLink": "Verbind ze →",
    "syncFromPlatforms": "Synchroniseer met platforms",
    "syncTooltip": "Haal de laatste posts op van Instagram, Facebook, LinkedIn en X. Handig voor IG — daar werken webhooks niet voor eigen posts.",
    "syncStarted": "Synchronisatie gestart — nieuwe posts verschijnen zo.",
    "syncFailed": "Synchronisatie mislukt. Probeer het zo opnieuw.",
    "content": "Inhoud",
    "charCount": "{{current}} / {{limit}}",
    "contentPlaceholder": "Schrijf je post…",
    "instagramMediaRequired": "Instagram vereist een afbeelding. Upload er een of genereer een template-visual hieronder.",
    "altTextRequiredForIG": "Alt-tekst is verplicht voor Instagram-berichten — verbetert toegankelijkheid + bereik.",
    "uploadMedia": "Afbeelding of video uploaden",
    "generateTemplate": "Genereer een template-visual (gratis, geen AI-kosten)",
    "generateReel": "Genereer als Instagram Reel (gebruikt Kling 2.6 Pro · ~60 seconden)",
    "scheduleLater": "Later plannen",
    "manualApprovedNote": "Handmatige posts slaan de beoordeling over en worden direct APPROVED.",
    "scheduleCount_one": "{{count}} post inplannen",
    "scheduleCount_other": "{{count}} posts inplannen",
    "publishCount_one": "{{count}} post publiceren",
    "publishCount_other": "{{count}} posts publiceren",
    "topic": "Onderwerp",
    "topicExample": "bijv. Productlancering, Wekelijkse tips, Achter de schermen…",
    "topicHint": "Korte omschrijving waar de post over gaat. Optioneel als je brontekst aanlevert.",
    "contentType": "Content-type",
    "contentTypeAuto": "Laat AI kiezen",
    "contentTypeHint": "Bepaalt de AI Visibility content-gap-grafiek. Laat \"Laat AI kiezen\" staan als je twijfelt — het model kiest op basis van je onderwerp.",
    "sourceText": "Brontekst (optioneel)",
    "sourceTextExample": "Plak bestaande tekst en de AI past deze aan per platform.\n\nBijvoorbeeld: een persbericht, een blogfragment, of een Slack-bericht dat je als social post wilt.",
    "sourceTextHint": "Als je tekst meegeeft, behoudt de AI je feiten en intentie maar herschrijft toon, lengte en opmaak per kanaal. Laat leeg om alleen op basis van het onderwerp te genereren.",
    "generationNote": "Gegenereerde drafts komen in je beoordelingsinbox. Je kunt daar per post een visual of reel toevoegen via de studio-modals.",
    "writingPosts": "Je posts worden geschreven…",
    "generationEta": "Meestal 5–15 seconden per platform",
    "platformDrafts_one": "{{count}} platform · 1 draft elk",
    "platformDrafts_other": "{{count}} platforms · 1 draft elk",
    "pickPlatform": "Kies minstens één platform",
    "editPost2": "Post bewerken",
    "publishedLocked": "Gepubliceerd — inhoud kan niet meer gewijzigd worden. Alleen opnieuw inplannen.",
    "editSubtitle": "Tekst, hashtags of planning bijwerken",
    "copy": "Tekst",
    "hashtags": "Hashtags",
    "hashtagExample": "oprichter, bouwen, nederlands",
    "hashtagHint": "Met komma's gescheiden. De # wordt automatisch toegevoegd bij publicatie.",
    "scheduledField": "Ingepland voor",
    "scheduleHint": "Leeg laten om als draft te bewaren. Het bewerken van de planning van een gepubliceerde post heeft geen effect.",
    "saveFailed": "Wijzigingen opslaan mislukt.",
    "platformEditLimitation": "De meeste platforms bieden geen edit-API aan.",
    "draftNote": "Opgeslagen drafts komen terug in je beoordelingsinbox.",
    "visualStudio": "Visual Studio",
    "visualStudioSubtitle": "Genereer AI-afbeeldingen voor deze post",
    "imagePrompt": "Afbeeldingsprompt",
    "visualAiPromptHint": "Leeg laten om de AI een prompt te laten schrijven op basis van de postinhoud en merkcontext.",
    "compareModels": "Modellen vergelijken",
    "compareModelsHint": "Draai dezelfde prompt op meerdere modellen tegelijk (1 afbeelding per model)",
    "toggleCompareMode": "Vergelijkmodus wisselen",
    "model": "Model",
    "modelsToCompare": "Modellen om te vergelijken ({{count}} geselecteerd)",
    "aspectRatio": "Beeldverhouding",
    "variations": "Variaties",
    "imagesCount_one": "{{count}} afbeelding",
    "imagesCount_other": "{{count}} afbeeldingen",
    "advancedControls": "Geavanceerde instellingen",
    "seed": "Seed",
    "seedPlaceholder": "Willekeurig (wordt na generatie ingevuld)",
    "seedHint": "Zet de seed vast om compositie stabiel te houden tijdens prompt-aanpassingen.",
    "lock": "Vergrendelen",
    "guidanceScale": "Guidance scale: {{value}}",
    "guidanceScaleHint": "Hoger = strikter vasthouden aan de prompt. Lager = creatiever. Standaard: 3.5",
    "inferenceSteps": "Inference steps: {{value}}",
    "inferenceStepsHint": "Meer stappen = hogere kwaliteit, meer kosten. Schnell standaard: 4. Dev standaard: 28.",
    "fluxProNote": "Flux Pro regelt de kwaliteit intern — guidance en steps zijn niet beschikbaar.",
    "generatingImages": "Afbeeldingen genereren…",
    "imagingGenEta": "Meestal 10–20 seconden",
    "pickOne": "Kies er één om te gebruiken",
    "generatedVariation": "Gegenereerde variatie",
    "selected": "Geselecteerd:",
    "useImage": "Gebruik deze afbeelding",
    "regenerate": "Opnieuw genereren",
    "regenerating": "Bezig met genereren…",
    "regenerateFailed": "Genereren mislukt",
    "reelStudio": "Reel Studio",
    "reelStudioSubtitle": "Genereer een 9:16-video met Kling 2.6 Pro",
    "renderingOverlay": "Overlay renderen…",
    "renderingOverlayNote": "Branded tekst samenstellen via Puppeteer + ffmpeg (~30s)",
    "textOverlay": "Tekstoverlay",
    "merkflowWatermark": "Merkflow-watermerk (admin)",
    "generatingReel": "Je reel wordt gegenereerd…",
    "reelGenEta": "Dit duurt meestal 1–3 minuten",
    "reelGenEtaAudio": "Reels met audio duren langer — meestal 5–8 minuten",
    "reelElapsed": "{{time}} verstreken",
    "runInBackground": "Op de achtergrond uitvoeren",
    "runInBackgroundNote": "Je kunt dit veilig sluiten — de generatie loopt door en de afgeronde reel verschijnt op de post.",
    "view": "Bekijken",
    "videoGenFailed": "Videogeneratie mislukt",
    "reelRetryHint": "Pas de prompt aan en probeer opnieuw",
    "noReelYet": "Nog geen reel gegenereerd",
    "reelSpec": "5–10 seconden video · 9:16 verticaal formaat",
    "postCopy": "Posttekst",
    "videoPrompt": "Videoprompt",
    "autoGenerateFromPost": "Automatisch genereren vanuit post",
    "videoPromptHint": "Beschrijf de cinematografische scene. 9:16 verticaal, 5–10 seconden. Geen tekstoverlay of echte gezichten.",
    "reelWithAudio": "Met audio genereren",
    "reelWithAudioHint": "Voegt gesynchroniseerd geluid toe. Telt mee voor je audio-aan reel-limiet (veel kleiner dan de audio-uit limiet). Valt automatisch terug op stil als je plan geen audio-reels heeft.",
    "reelTips": "Tips voor goede reels",
    "reelTip1": "Beschrijf beweging en camerabewegingen (pan, zoom, reveal)",
    "reelTip2": "Gebruik specifieke visuele details (licht, texturen, kleuren)",
    "reelTip3": "Houd het simpel — één scene werkt beter dan veel cuts",
    "reelTip4": "Vermijd tekst, logo's of menselijke gezichten in de prompt",
    "triggeringReel": "Reel-generatie starten…",
    "bgGenerationNote": "Generatie draait op de achtergrond — je kunt dit dialoogvenster sluiten",
    "reelPricing": "9:16 verticaal · 10 seconden · telt als 1 reel van je maandquotum",
    "reelStep1": "Verzoek ingediend",
    "reelStep1Desc": "In de wachtrij bij fal.ai",
    "reelStep2": "Video genereren",
    "reelStep2Desc": "Rendert — 1–3 min (langer met audio)",
    "reelStep3": "Overlay toepassen",
    "reelStep3Desc": "Branding + tekst via ffmpeg",
    "reelStep4Desc": "Reel is klaar",
    "carouselStudio": "Carousel Studio",
    "carouselSubtitle": "LinkedIn-carousels krijgen 3× meer bereik dan tekstposts",
    "slidesGenerated_one": "{{count}} slide gegenereerd",
    "slidesGenerated_other": "{{count}} slides gegenereerd",
    "downloadPdf": "PDF downloaden",
    "carouselPlaceholder": "5–8 carousel-slides worden gegenereerd",
    "carouselPlaceholderHint": "AI splitst je post in slides · Puppeteer rendert de PDF",
    "carouselGenFailed": "Carousel-generatie mislukt.",
    "generatingCarousel": "Carousel genereren…",
    "carouselGenEta": "AI schrijft de slides, Puppeteer rendert de PDF (15–30 seconden)",
    "carouselReady_one": "{{count}} slide · PDF klaar",
    "carouselReady_other": "{{count}} slides · PDF klaar",
    "noCarousel": "Nog geen carousel",
    "regenerateCarousel": "Carousel opnieuw genereren",
    "generateCarousel": "Carousel genereren",
    "postTrace": "Post-levenscyclus trace",
    "loadingTrace": "Audit log laden…",
    "traceEventCount_one": "{{count}} event in de audit log",
    "traceEventCount_other": "{{count}} events in de audit log",
    "traceLoadFailed": "Audit log laden mislukt.",
    "noTraceEvents": "Nog geen audit events voor deze post.",
    "traceNote": "De levenscyclus log start met opnemen zodra V45 is uitgerold. Bestaande posts van voor die tijd tonen alleen events van nieuwe transities.",
    "statusLabel": "Status:",
    "reviewLabel": "Beoordeling:",
    "platformLabel": "Platform:",
    "publishedLabel": "Gepubliceerd:",
    "colPost": "Post",
    "colBrand": "Merk",
    "colPlatform": "Platform",
    "colStatus": "Status",
    "colDate": "Datum",
    "inline": {
      "copyPlaceholder": "Schrijf de posttekst…",
      "tagPlaceholderEmpty": "Voeg een hashtag toe…",
      "tagPlaceholderMore": "Nog een toevoegen…",
      "removeTag": "Verwijder #{{tag}}",
      "hashtagCount": "{{count}} / {{max}} tags",
      "tagSoftWarn": "Boven de aanbevolen limiet — bereik kan dalen.",
      "saving": "Opslaan…",
      "saved": "Opgeslagen",
      "saveError": "Opslaan mislukt",
      "editTooltip": "Klik om hashtags te bewerken",
      "editHint": "Enter / komma om toe te voegen · Esc om te sluiten",
      "emptyHint": "Klik om hashtags toe te voegen"
    },
    "table": {
      "reach": "Bereik",
      "engagement": "Engagement",
      "er": "ER"
    },
    "drawer": {
      "openTooltip": "Open analytics",
      "openOnPlatform": "Open op platform",
      "byBrand": "Door {{brand}}",
      "noAnalytics": "Nog geen analytics. Cijfers verschijnen na de volgende sync.",
      "reach": "Bereik",
      "engagement": "Engagement",
      "er": "Engagement rate",
      "breakdown": "Uitsplitsing",
      "likes": "Likes",
      "comments": "Reacties",
      "shares": "Gedeeld",
      "views": "Weergaven",
      "clicks": "Kliks",
      "details": "Details",
      "publishedAt": "Gepubliceerd",
      "scheduledAt": "Gepland",
      "createdAt": "Aangemaakt",
      "account": "Account"
    },
    "traceSummary": "Bron: post_events — elke statusverandering wordt vastgelegd.",
    "inferred": "afgeleid",
    "eventCreated": "Aangemaakt",
    "eventEdited": "Bewerkt",
    "eventVisualGenerated": "Visual gegenereerd",
    "eventCarouselGenerated": "Carousel gegenereerd",
    "eventReelPending": "Reel in wachtrij",
    "eventReelReady": "Reel klaar",
    "eventReelFailed": "Reel mislukt",
    "eventApproved": "Goedgekeurd",
    "eventRejected": "Afgewezen",
    "eventRegenerated": "Opnieuw gegenereerd",
    "eventScheduled": "Ingepland",
    "eventPublishAttempt": "Publicatiepoging",
    "eventPublished": "Gepubliceerd",
    "eventPublishFailed": "Publicatie mislukt",
    "eventEditedOnPlatform": "Bewerkt op platform",
    "eventDeletedOnPlatform": "Verwijderd van platform",
    "eventArchived": "Gearchiveerd",
    "eventFallback": "Event",
    "decisionPublishConnectionResolved": "Publish — account gekozen",
    "decisionPublishSkipped": "Publish — overgeslagen",
    "decisionDeletePlatformAttempted": "Verwijder — platform-call",
    "decisionDeletePlatformSkippedIg": "Verwijder — IG niet ondersteund",
    "decisionDeletePlatform404": "Verwijder — klaar",
    "decisionDeleteLocalOnly": "Verwijder — alleen lokaal",
    "decisionVisualRoutedPuppeteer": "Visual — Puppeteer",
    "decisionVisualRoutedFal": "Visual — fal.ai",
    "decisionVisualFalFallback": "Visual — fal.ai fallback",
    "decisionReelRoutedMock": "Reel — mock",
    "decisionSyncMediaClassified": "Sync — media-type",
    "contentTypeEducational": "Educatief",
    "contentTypeSocialProof": "Social proof",
    "contentTypeThoughtLeadership": "Thought leadership",
    "contentTypeProductHighlight": "Product",
    "contentTypeIndustryReaction": "Branche",
    "contentTypeBehindTheScenes": "Behind the scenes",
    "editedOnPlatform": "Bewerkt op platform · {{ago}}",
    "crossBrandPostedBy": "Geplaatst door",
    "crossBrandAbout": "Over",
    "twitterTruncateWarning": "{{count}} tekens — deze post wordt automatisch opgesplitst in een thread op X (280 tekens per tweet).",
    "aiVisualOnPublish": "AI-beeld wordt bij publicatie gegenereerd",
    "chooseVisual": "Kies beeld",
    "storylineFallback": "Verhaallijn",
    "userUploadedMedia": "Zelf geüploade media",
    "aiVisualIgnored": "AI-beeld genegeerd",
    "generateVisual": "Beeld genereren",
    "generateReelShort": "Reel genereren",
    "createReel": "Reel maken",
    "trace": "Tracer",
    "traceLifecycle": "Levenscyclus tracen",
    "viewLive": "Live bekijken",
    "publishNow": "Nu publiceren",
    "republish": "Opnieuw publiceren",
    "republishConfirm": "Deze post opnieuw publiceren? De versie op het platform wordt verwijderd (waar ondersteund) en binnen een minuut gaat er een nieuwe live.",
    "altText": {
      "label": "Alt-tekst",
      "optionalHint": "— optioneel, vergroot bereik",
      "whyTitle": "Waarom invullen?",
      "whyAlgo": "Het algoritme van Instagram leest alt-tekst om te begrijpen waar je afbeelding over gaat. Het bepaalt mede aan de hand hiervan wie je post te zien krijgt.",
      "whySearch": "Alt-tekst wordt ook geïndexeerd door Google en AI-zoektools, dus een goede beschrijving helpt mensen je ook buiten Instagram te vinden.",
      "whyHowto": "Houd het simpel. 1–2 zinnen die beschrijven wat er in de afbeelding staat, met één of twee zoekwoorden. Geen hashtags.",
      "placeholder": "Dashboard met een wekelijkse content-planning voor een multi-brand operator, met post-previews voor LinkedIn en Instagram",
      "bodyCaption": "Beschrijft de afbeelding voor toegankelijkheid en Instagram's zoekindex. Houd het onder de 280 tekens voor het beste bereik. Laat leeg als je twijfelt — posten zonder alt-tekst werkt nog steeds, het helpt alleen minder."
    },
    "playReel": "Reel afspelen",
    "viewFullScreen": "Volledig scherm",
    "postVisual": "Post-beeld",
    "postVisualFullSize": "Post-beeld — volledige grootte",
    "carouselSlide1": "Slide 1",
    "carouselReady": "Carrousel klaar",
    "carouselSwipe": "Swipe →",
    "commentsWithCount": "Reacties · {{count}}",
    "someoneCommenter": "Iemand",
    "replyPrefix": "Reactie:",
    "showLess": "Toon minder",
    "showAllCount": "Toon alle {{count}}",
    "noAccountConnected": "Geen {{platform}}-account gekoppeld",
    "postAs": "Post als",
    "postAsAccount": "Post als account",
    "selectAccount": "Kies een account…",
    "unnamedAccount": "(zonder naam)",
    "generationFailed": "Genereren mislukt",
    "commitFailed": "Opslaan mislukt",
    "noImageSelected": "Geen afbeelding geselecteerd",
    "uploadYourOwn": "Eigen afbeelding uploaden",
    "uploadYourOwnHint": "AI overslaan — upload een kant-en-klaar beeld (JPG/PNG/WebP).",
    "chooseImage": "Afbeelding kiezen",
    "statusPublished": "Gepubliceerd",
    "statusSynced": "Gesynct van platform",
    "syncedShort": "Gesynct",
    "statusScheduled": "Ingepland",
    "statusDraft": "Concept",
    "statusPending": "In afwachting",
    "statusApproved": "Goedgekeurd",
    "statusRejected": "Afgewezen",
    "statusFailed": "Mislukt",
    "statusInReview": "In beoordeling",
    "statusPendingPublish": "Publiceren",
    "statusArchived": "Gearchiveerd"
  },
  "analytics": {
    "title": "Analyses",
    "linkedinImport": {
      "button": "LinkedIn data importeren",
      "tooltip": "Upload een LinkedIn-statistieken-export om metrics aan te vullen die LinkedIn niet via de API levert.",
      "pickerTitle": "Kies een LinkedIn-account",
      "pickerHint": "Je hebt meerdere LinkedIn-accounts. Kies bij welke deze export hoort."
    },
    "deltaTooltip": "t.o.v. vorige periode (zelfde lengte als huidige selectie)",
    "reach": "Bereik",
    "totalReach": "Totaal bereik",
    "engagements": "Interacties",
    "impressions": "Vertoningen",
    "likes": "Likes",
    "comments": "Reacties",
    "shares": "Gedeeld",
    "followers": "Volgers",
    "noData": "Nog geen analysegegevens.",
    "postsPublished": "Gepubliceerde posts",
    "zeroNote": "Analyses worden door het platform met 24–48 uur vertraging gerapporteerd.",
    "postsByType": "Posts per type",
    "performanceOverTime": "Prestaties over tijd",
    "topPosts": "Top posts",
    "last7days": "Laatste 7 dagen",
    "last30days": "Laatste 30 dagen",
    "last90days": "Laatste 90 dagen",
    "published": "Gepubliceerd",
    "withReach": "Met bereik",
    "withLikes": "Met likes",
    "withComments": "Met reacties",
    "withShares": "Gedeeld",
    "account": "Account",
    "filterByAccount": "Filter op postaccount",
    "allAccounts": "Alle accounts",
    "reachOverview": "Bereikoverzicht",
    "last30LiveData": "Afgelopen 30 dagen · live data",
    "noReachYet": "Nog geen bereikdata. Publiceer een post om te starten.",
    "postsOverTime": "Posts in de tijd",
    "last30ByPlatform": "Afgelopen 30 dagen · per platform",
    "noPostsInWindow": "Nog geen posts gepubliceerd in deze periode.",
    "platformSplit": "Verdeling per platform",
    "byReach": "Op bereik",
    "byPostsPublished": "Op gepubliceerde posts",
    "noDataYet": "Nog geen data",
    "contentFunnel": "Content funnel",
    "topPerformingPosts": "Best presterende posts",
    "noPublishedPostsPeriod": "Geen gepubliceerde posts gevonden voor deze periode.",
    "colPost": "Post",
    "colPlatform": "Platform",
    "colAccount": "Account",
    "colBrand": "Merk",
    "colPublished": "Gepubliceerd",
    "colReach": "Bereik",
    "colLikes": "Likes",
    "colER": "ER",
    "noPostsInWindowShort": "Geen posts in deze periode.",
    "avgEngagement": "Gem. engagement",
    "videoViews": "Videoweergaven",
    "openBreakdown": "Open uitsplitsing voor {{label}}",
    "breakdownTitle": "Uitsplitsing",
    "breakdownSubtitle": "{{count}} posts bijdragend — top 50 getoond",
    "breakdownEmpty": "Geen posts droegen bij aan deze metric in de huidige periode.",
    "bestPostReach": "Beste bereik",
    "totalLikes": "Totaal likes",
    "dataIntelligence": "Data-intelligentie",
    "dataIntelligenceSubtitle": "Realtime inzichten en postprestaties",
    "filter_today": "Vandaag",
    "filter_week": "Week",
    "filter_month": "Maand",
    "filter_year": "Jaar",
    "syncNow": "Nu syncen",
    "export": {
      "button": "Exporteren",
      "csv": "Download CSV",
      "pdf": "Download PDF-rapport",
      "generating": "PDF wordt gegenereerd…"
    },
    "brandLabel": "Merk",
    "allBrands": "Alle merken",
    "tabOverview": "Overzicht",
    "reachZeroTitle": "Bereik en engagement op nul?",
    "reachZeroIntro": "De Meta API geeft 0 terug voor accounts met minder dan 100 volgers, en data kan tot 48 uur duren na publicatie. Dit is een bevestigde Meta-limitatie — geen sync-fout. Gepubliceerde posts toont",
    "reachZeroAccurate": "dat klopt wel.",
    "runSync": "Sync uitvoeren",
    "toPullLatest": "om de nieuwste data op te halen.",
    "noPlatformData": "Nog geen platformdata. Koppel een account om te starten.",
    "platformBreakdown": "Per platform",
    "perPlatformTotals": "Totalen per platform voor deze periode",
    "topPostThisPeriod": "Topost van deze periode",
    "unknownBrand": "Onbekend merk",
    "unpublished": "Niet gepubliceerd",
    "platform": {
      "tabLabel": {
        "linkedin": "LinkedIn",
        "instagram": "Instagram",
        "facebook": "Facebook",
        "x": "X",
        "blog": "Blog"
      },
      "tile": {
        "impressions": "Impressies",
        "reach": "Bereik",
        "uniqueReach": "Uniek bereik",
        "engagementRate": "Engagement rate",
        "ctr": "Klik-doorklik-ratio",
        "totalReactions": "Totale reacties",
        "saves": "Opgeslagen",
        "totalInteractions": "Totale interacties",
        "profileVisits": "Profielbezoeken",
        "likes": "Likes",
        "comments": "Reacties",
        "shares": "Gedeeld",
        "linkClicks": "Linkkliks",
        "retweets": "Retweets",
        "quotes": "Quotes",
        "replies": "Replies",
        "bookmarks": "Bookmarks"
      },
      "topPostsTitle": "Best presterende posts",
      "noPostsInWindow": "Geen posts op dit platform in het geselecteerde venster.",
      "noTimeseriesYet": "Nog geen dagelijkse data — kom terug na de volgende sync.",
      "noEngagementYet": "Nog geen engagement gerapporteerd",
      "noEngagementHint": "Platforms hebben 24–48 uur nodig om impressies op nieuwe posts te rapporteren.",
      "noReactionsYet": "Nog geen reacties op posts in deze periode.",
      "heroHintImpressionsReach": "Impressies en uniek bereik over tijd",
      "heroHintReach": "Bereik over tijd",
      "linkedin": {
        "heroTitle": "Bereik over tijd",
        "engagementMixTitle": "Engagement-mix",
        "gaugeTitle": "Engagement rate",
        "gaugeHint": "tegen B2B-benchmark",
        "benchmarkCaption": "B2B-benchmark: {{benchmark}}%",
        "sortBy": "Gesorteerd op totale engagement",
        "org": {
          "title": "{{page}} — paginastatistieken",
          "followers": "Volgers",
          "followerGain": "Nieuwe volgers (organisch)",
          "pageViews": "Paginaweergaven",
          "shareEngagement": "Post-engagement",
          "followerTrend": "Volgersgroei",
          "pageViewsBySection": "Paginaweergaven per sectie",
          "trendEmpty": "De volgerstrend verschijnt na enkele dagen synchroniseren.",
          "pageViewsEmpty": "Nog geen paginaweergaven.",
          "empty": "LinkedIn-paginastatistieken synchroniseren 's nachts — kom morgen terug."
        }
      },
      "instagram": {
        "heroTitle": "Bereik + opgeslagen",
        "heroHint": "Saves zijn het waardevolste engagementsignaal op Instagram",
        "contentMixTitle": "Reels vs Feed",
        "saveRateTitle": "Save rate",
        "saveRateHint": "saves per bereik",
        "saveRateCaption": "1% prima · 3% sterk",
        "profileVisitsEmpty": "Profielbezoeken vereist uitgebreide API-toegang — wordt opgevolgd.",
        "reels": "Reels",
        "feed": "Feed-posts",
        "reelsShare": "van recente posts zijn reels",
        "reelViews": "totale reel-views",
        "sortBy": "Gesorteerd op saves"
      },
      "facebook": {
        "heroTitle": "Bereik over tijd",
        "reactionsTitle": "Reacties per type",
        "sentimentTitle": "Sentiment-ratio",
        "sentimentHint": "positief : negatief",
        "sentimentCaption": "5:1 gezond · 1:1 gemengd",
        "reactions": {
          "like": "Like",
          "love": "Love",
          "haha": "Haha",
          "wow": "Wow",
          "sorry": "Sorry",
          "anger": "Anger"
        },
        "videoTitle": "Videoprestaties",
        "videoSummary": "{{views}} totale videoweergaven in dit venster.",
        "sortBy": "Gesorteerd op reacties"
      },
      "x": {
        "engagementMixTitle": "Engagement-mix",
        "engagementMixHint": "Likes / retweets / quotes / replies dagelijks gestapeld",
        "bookmarkRateTitle": "Bookmark-rate",
        "bookmarkRate": "Bookmark-rate",
        "quoteMagnetTitle": "Quote-magneet",
        "quoteMagnetUnit": ":1 RT",
        "quoteMagnetHint": "quotes per retweet",
        "quoteMagnetCaption": "1:5+ start discussie",
        "urlClicksTitle": "URL-kliks",
        "urlClicksHint": "Echte linkkliks (X non-public metrics)",
        "profileVisitsHint": "Bezoeken vanuit deze posts",
        "sortBy": "Gesorteerd op impressies"
      }
    }
  },
  "chatbot": {
    "title": "Merkflow AI",
    "open": "Open AI-assistent",
    "history": "Geschiedenis",
    "newConversation": "Nieuw gesprek",
    "placeholder": "Stel me een vraag…",
    "send": "Verzenden",
    "noConversations": "Nog geen gesprekken. Start er een!",
    "deleteConfirm": "Verwijderen?",
    "delete": "Verwijderen",
    "cancel": "Annuleren",
    "usageCounter": "{{used}} / {{limit}} berichten deze maand",
    "usageUnlimited": "Onbeperkt berichten",
    "limitReached": "Je hebt het berichtenlimiet van je {{plan}}-plan bereikt ({{limit}}/maand). Upgrade naar Pro voor 500 berichten per maand.",
    "upgradeLink": "Upgraden",
    "welcomeTitle": "Hoi! Ik ben de Merkflow AI-assistent.",
    "welcomeBody": "Ik help je met content maken, je analytics begrijpen, verbindingsproblemen oplossen en meer. Waar kan ik je mee helpen?",
    "welcomePrompt1": "Schrijf een LinkedIn-post over onze nieuwste feature",
    "welcomePrompt2": "Waarom werkt mijn Instagram-koppeling niet?",
    "welcomePrompt3": "Leg mijn GEO-score uit",
    "disabled": "De AI-assistent is tijdelijk niet beschikbaar.",
    "thinking": "Even denken…",
    "errorGeneric": "Er ging iets mis. Probeer het opnieuw.",
    "back": "Terug naar geschiedenis",
    "close": "Sluiten",
    "openReview": "Open Review-inbox"
  },
  "engagement": {
    "title": "Engagement",
    "subtitle": "Reacties, comments en vermeldingen op elk verbonden platform.",
    "inbox": "Inbox",
    "noMessages": "Geen berichten.",
    "noNewMessages": "Geen nieuwe berichten",
    "emptyDescription": "Zodra volgers reageren of je noemen, verschijnen hun berichten hier.",
    "allItems_one": "Alle items ({{count}})",
    "allItems_other": "Alle items ({{count}})",
    "markRead": "Markeer als gelezen",
    "markResolved": "Markeer als opgelost",
    "resolve": "Oplossen",
    "reply": "Antwoorden",
    "replySent": "Antwoord verstuurd",
    "deleteOwn": "Reactie verwijderen",
    "deleteOwnTooltip": "Verwijder deze reactie zowel op het platform als lokaal.",
    "deleteOwnConfirm": "Deze reactie van het platform verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "comment": "Reactie",
    "mention": "Vermelding",
    "unread": "Ongelezen",
    "aiSuggestion": "AI-suggestie",
    "regenerating": "Opnieuw genereren…",
    "regenerate": "Opnieuw genereren",
    "useSuggestion": "Gebruik deze suggestie →",
    "yourReply": "Je antwoord",
    "placeholderReply": "Schrijf een antwoord...",
    "sendReply": "Antwoord versturen",
    "selectMessage": "Kies een bericht",
    "selectDescription": "Kies een item uit de lijst links om te lezen en te antwoorden.",
    "noNewComments": "Nog geen nieuwe reacties",
    "appearAsTheyArrive": "Interacties verschijnen hier zodra ze binnenkomen",
    "viewAllNotifications": "Alle meldingen bekijken →",
    "commented": "reageerde",
    "reacted": "Like",
    "sentimentPositive": "Positief",
    "sentimentNegative": "Negatief",
    "sentimentNeutral": "Neutraal",
    "filterAll": "Alle",
    "filterUnread": "Ongelezen",
    "filterMentions": "Vermeldingen",
    "filterComments": "Reacties",
    "filterResolved": "Opgelost",
    "postContextUnavailable": "Postcontext niet beschikbaar",
    "viewOnPlatform": "Bekijk op {{platform}}",
    "viaConnection": "via {{name}}",
    "contentUnavailable": "Inhoud kon niet worden geladen",
    "replyingTo": "Antwoord op @{{handle}}",
    "resolveThread": "Thread oplossen",
    "markAsRead": "Markeer als gelezen",
    "emptyAllFirst": "Nog geen engagement. Reacties, antwoorden en vermeldingen van je verbonden accounts verschijnen hier.",
    "emptyAllReturning": "Je bent helemaal bij.",
    "emptyUnread": "Je bent helemaal bij.",
    "emptyMentions": "Nog geen vermeldingen. Als iemand een van je merken @-tagt op Instagram, verschijnt dat hier.",
    "emptyComments": "Nog geen reacties.",
    "emptyResolved": "Nog niets opgelost.",
    "selectThread": "Selecteer een thread om het gesprek te zien.",
    "threadUnreadCount_one": "{{count}} ongelezen",
    "threadUnreadCount_other": "{{count}} ongelezen",
    "threadItemCount_one": "{{count}} reactie",
    "threadItemCount_other": "{{count}} reacties",
    "mentionedYou": "heeft je vermeld",
    "likedYourPost": "vond je bericht leuk",
    "linkedinMember": "LinkedIn-lid",
    "you": "jij",
    "allBrands": "Alle merken"
  },
  "connections": {
    "title": "Verbindingen",
    "subtitle": "Social accounts die aan deze werkruimte gekoppeld zijn.",
    "connect": "Verbinden",
    "disconnect": "Verbreken",
    "reconnect": "Opnieuw verbinden",
    "connected": "verbonden",
    "expired": "Verlopen",
    "noConnections": "Nog geen accounts verbonden",
    "connectSuccess": "{{platform}} succesvol verbonden.",
    "linkedinPickerTitle_one": "Je hebt {{count}} LinkedIn-pagina toegevoegd",
    "linkedinPickerTitle_other": "Je hebt {{count}} LinkedIn-pagina's toegevoegd",
    "linkedinPickerSubtitle": "Houd de pagina's die je wilt — verwijder de rest. Je kunt later altijd opnieuw verbinden.",
    "linkedinPickerRemove": "Verwijderen",
    "linkedinPickerDone": "Klaar",
    "connectPlatform": "{{platform}} verbinden",
    "connectAnother": "+ Nog een {{platform}} verbinden",
    "linkedinPersonal": "+ Persoonlijke LinkedIn",
    "linkedinCompany": "+ LinkedIn bedrijfspagina",
    "importAnalytics": {
      "button": "Statistieken importeren",
      "title": "LinkedIn-statistieken importeren",
      "subtitle": "Upload de statistieken-export voor {{name}}.",
      "howTo": "Open op LinkedIn de pagina-admin (of je persoonlijke statistieken) en klik op \"Exporteren\". Sla het bestand op en sleep het hierheen. We koppelen de rijen aan je Merkflow-posts via de LinkedIn activity-URN en vullen impressies, klikken, likes, reacties en reposts aan.",
      "dropzone": "Klik om een bestand te kiezen",
      "start": "Import starten",
      "uploadError": "Bestand kon niet worden geüpload. Zorg dat het de LinkedIn XLS-export is.",
      "canCloseHint": "Je mag dit venster sluiten — de import gaat op de achtergrond door.",
      "status": {
        "pending": "In wachtrij…",
        "running": "Parsen en koppelen aan posts…"
      },
      "done": "Import voltooid",
      "failed": "Import mislukt",
      "tryAgain": "Probeer een ander bestand",
      "completedToast": "LinkedIn-statistieken geïmporteerd.",
      "backfillLabel": "Maak Merkflow-posts voor onkoppelde rijen aan",
      "backfillHint": "Aanbevolen voor company-exports — voegt de historische post-tekst + statistieken toe aan het dashboard van dit merk. Vereist dat de verbinding is ingesteld als LinkedIn-standaard voor een merk. Persoonlijke export-rijen kunnen niet worden teruggevuld (LinkedIn levert de post-tekst niet aan).",
      "backfillPersonalNote": "Niet beschikbaar voor persoonlijke accounts — de persoonlijke LinkedIn-export bevat de post-tekst niet, dus we kunnen er geen posts van aanmaken. Statistieken worden nog steeds toegepast op posts die Merkflow al kent.",
      "summary": {
        "format": "Formaat:",
        "totalRows": "Posts in export:",
        "matchedUrn": "Direct gekoppeld (URN):",
        "matchedFuzzy": "Fuzzy gekoppeld:",
        "backfilled": "Posts aangemaakt uit export:",
        "unmatched": "Niet gekoppeld:",
        "followerUpdated": "Aantal volgers bijgewerkt.",
        "unmatchedHint": "Deze posts konden niet worden gekoppeld aan een Merkflow-post:"
      }
    },
    "linkedinManual": "+ Handmatige bedrijfspagina",
    "linkedinManualHint": "Geen OAuth nodig. Genereer posts in Merkflow en plaats ze daarna handmatig op LinkedIn. Handig zolang de Community Management API-goedkeuring nog loopt.",
    "linkedinManualTitle": "Handmatige LinkedIn bedrijfspagina toevoegen",
    "linkedinManualDescription": "Maak een verbinding zonder OAuth aan. Gegenereerde posts verschijnen in je review-inbox; publiceren gebeurt door de content handmatig naar LinkedIn te kopiëren.",
    "linkedinManualNameLabel": "Naam",
    "linkedinManualNamePlaceholder": "bijv. Ludicrous Dukes",
    "linkedinManualNameRequired": "Naam is verplicht.",
    "linkedinManualUrlLabel": "URL van bedrijfspagina (optioneel)",
    "linkedinManualUrlHint": "Tip: plak de LinkedIn admin-URL (bijv. https://www.linkedin.com/company/89594379/admin/dashboard/) — \"Openen in LinkedIn\" springt dan direct naar de pagina-admin compose. Zonder admin-URL openen we de publieke pagina en klik je zelf op \"Pagina beheren\".",
    "linkedinManualSubmit": "Toevoegen",
    "linkedinManualError": "Handmatige verbinding kon niet worden aangemaakt.",
    "manualOnly": "Alleen handmatig",
    "manualOnlyHint": "Geen OAuth-token. Posts voor deze verbinding moet je handmatig vanuit LinkedIn publiceren.",
    "connectDescription": "Verbind Instagram, Facebook of LinkedIn om te beginnen met publiceren via Merkflow.",
    "expiredMessage": "Je verbinding is verlopen. Verbind opnieuw.",
    "none": "Nog geen verbindingen.",
    "disconnectConfirm": "{{platform}} verbreken? Er wordt dan niet meer naar dit account gepubliceerd.",
    "lastSynced": "Laatst gesynchroniseerd {{time}}",
    "accounts_one": "{{count}} account",
    "accounts_other": "{{count}} accounts",
    "oauthError": "Kon {{platform}}-OAuth niet starten.",
    "reconnectToUpdate": "opnieuw verbinden om bij te werken",
    "tokenExpires": "Token verloopt {{date}}",
    "followers": "{{count}} volgers",
    "webhookSettings": "Webhook-instellingen",
    "metaWebhooks": "Meta Webhooks",
    "metaWebhooksDescription": "Realtime meldingen van reacties op Facebook en Instagram. Abonneer je verbonden pagina's om direct engagement-updates te ontvangen.",
    "xWebhooks": "X Webhooks",
    "xWebhooksDescription": "Realtime meldingen van vermeldingen en replies op X. Nieuwe connecties abonneren automatisch — gebruik dit om accounts bij te werken die verbonden waren vóór webhooks live gingen, of als noodoplossing als een abonnement uitvalt.",
    "subscribeAll": "Alles abonneren",
    "subscribing": "Abonneren...",
    "subscriptionSuccess_one": "{{count}} account geabonneerd op webhooks.",
    "subscriptionSuccess_other": "{{count}} accounts geabonneerd op webhooks.",
    "subscriptionFailed": "Mislukt: {{failed}} van {{total}} account(s) kon niet abonneren. Verbind opnieuw met de nieuwe scope.",
    "noFacebookPages": "Geen Facebook-pagina's gevonden om te abonneren.",
    "noXAccounts": "Geen X-accounts gevonden om te abonneren — of ze zijn allemaal al geabonneerd.",
    "subscriptionError": "Abonneren mislukt: {{message}}",
    "webhookActive": "Webhook actief",
    "webhookNeedsAuth": "Webhook: extra autorisatie nodig",
    "webhookPending": "Webhook: in behandeling",
    "webhookNotRegistered": "Webhook: URL niet geregistreerd",
    "webhookNotSubscribed": "Webhook: niet geabonneerd",
    "webhookTokenExpired": "Webhook: token verlopen — verbind opnieuw",
    "webhookMissingAccount": "Webhook: account niet gekoppeld",
    "webhookProblem": "Webhook: probleem",
    "xEnableWebhooksHint": "Realtime vermeldingen vereisen een eenmalige extra autorisatie. Klik hieronder om toestemming te geven.",
    "xEnableWebhooks": "Webhooks activeren",
    "xWebhookEnabledSuccess": "X-webhook-autorisatie verleend. Vermeldingen komen nu realtime binnen.",
    "xWebhookEnabledError": "X-webhook-autorisatie mislukt: {{message}}",
    "viewTrace": "Activiteit bekijken",
    "renameAccount": "Klik om te hernoemen",
    "unclaimed": "Niet gekoppeld aan een merk",
    "unclaimedHint": "Geen enkel merk gebruikt dit account standaard. Stel het in als standaard bij een merk om het mee te nemen in geplande posts.",
    "traceTitle": "Activiteit van verbinding",
    "traceEmpty": "Nog geen activiteit. Sync- en publicatie-events verschijnen hier.",
    "traceInputs": "in",
    "traceOutputs": "uit",
    "traceFallback": "Gebeurtenis",
    "traceBrandResolved": "Merk bepaald",
    "traceBrandSkipped": "Merk overgeslagen",
    "traceSyncComplete": "Sync voltooid",
    "traceSyncFailed": "Sync mislukt",
    "traceTokenRefreshed": "Token ververst",
    "traceTokenExpired": "Token verlopen",
    "traceWebhookReceived": "Webhook ontvangen",
    "traceWebhookRejected": "Webhook afgewezen"
  },
  "workspace": {
    "title": "Werkruimte",
    "members": "Leden",
    "inviteMembers": "Leden uitnodigen",
    "createWorkspace": "Werkruimte aanmaken",
    "createNew": "Nieuwe werkruimte aanmaken",
    "switchWorkspace": "Werkruimte wisselen",
    "selectWorkspace": "Werkruimte selecteren",
    "paused": {
      "title": "Deze werkruimte is gepauzeerd",
      "body": "Alle acties staan op alleen-lezen. Upgrade naar een betaald abonnement om door te gaan, of wissel naar een andere werkruimte.",
      "switchHint": "of wissel werkruimte ↑"
    },
    "trialExpired": {
      "title": "Je proefperiode is afgelopen",
      "body": "Alleen-lezen modus actief totdat je upgrade. Nieuwe posts, generaties en verbindingen zijn uitgeschakeld."
    },
    "createTitle": "Werkruimte aanmaken",
    "createSubtitle": "Elke werkruimte heeft eigen merken, leden en verbindingen.",
    "nameLabel": "Naam werkruimte",
    "namePlaceholder": "Acme Marketing",
    "createNote": "Je wordt de eigenaar. Nodig teamleden uit via Instellingen → Leden nadat je de werkruimte hebt aangemaakt.",
    "creating": "Aanmaken…",
    "createButton": "Werkruimte aanmaken",
    "nameRequired": "Naam werkruimte is verplicht",
    "role_OWNER": "eigenaar",
    "role_ADMIN": "admin",
    "role_MEMBER": "lid",
    "role_VIEWER": "kijker"
  },
  "plans": {
    "trial": "Proefperiode",
    "starter": "Starter",
    "pro": "Pro",
    "agency": "Agency",
    "upgradeRequired": "Upgrade vereist",
    "upgrade": "Upgrade",
    "trialDaysLeft": "{{days}} dagen over in proefperiode",
    "trialExpired": "Proefperiode verlopen",
    "trialEnds": "Proefperiode eindigt {{date}}",
    "daysLeft": "{{count}} dagen over",
    "adminOverride": "Admin-override",
    "planLocked": "Abonnement vergrendeld door admin — geen facturatie."
  },
  "billing": {
    "title": "Facturatie",
    "subtitle": "Abonnement, gebruik en betaling voor deze werkruimte.",
    "currentPlan": "Huidig abonnement",
    "upgradeCta": "Upgrade abonnement",
    "trialEnded": "Je proefperiode is afgelopen. Upgrade om deze werkruimte te blijven gebruiken.",
    "trialEndsIn_one": "Je proefperiode eindigt over {{days}} dag ({{date}})",
    "trialEndsIn_other": "Je proefperiode eindigt over {{days}} dagen ({{date}})",
    "trialEndsToday": "Je proefperiode eindigt vandaag — upgrade vóór het einde van de dag om je werkruimte te behouden.",
    "renewsOn": "Verlengt {{date}}",
    "cancelledAccessUntil": "Abonnement opgezegd — toegang tot {{date}}",
    "subscriptionEnded": "Je abonnement is afgelopen. Heractiveer een betaald plan om deze werkruimte te blijven gebruiken.",
    "processing": "Betaling wordt verwerkt… je abonnement wordt bijgewerkt zodra Mollie bevestigt.",
    "processingTimeout": "Nog steeds aan het verwerken. Dit duurt soms enkele minuten — probeer zo te verversen.",
    "cancelSubscription": "Abonnement opzeggen",
    "cancelling": "Opzeggen…",
    "ownerOnly": "Alleen de werkruimte-eigenaar kan het abonnement wijzigen.",
    "cancelConfirm": "Abonnement opzeggen? Je werkruimte wordt aan het einde van de huidige factuurperiode gepauzeerd.",
    "usageThisMonth": "Gebruik deze maand",
    "monthly": "Maandelijks",
    "annual": "Jaarlijks",
    "annualSavings": "bespaar 2 maanden",
    "toggleAnnual": "Jaarprijs wisselen",
    "currentPlanButton": "Huidig abonnement",
    "startPlan": "{{plan}} starten",
    "switchPlan": "Overstappen naar {{plan}}",
    "ownerOnlyMessage": "Alleen werkruimte-eigenaren kunnen het abonnement wijzigen.",
    "loadingPlan": "Werkruimte-abonnement laden…",
    "notAvailable": "— niet beschikbaar",
    "accountSuspended": "Account opgeschort",
    "suspendedDescription": "Je account is tijdelijk opgeschort. Upgrade je abonnement of neem contact op met support om toegang te herstellen.",
    "upgradeToRestore": "Abonnement upgraden",
    "perYearShort": "jaar",
    "perMonthShort": "mnd",
    "starterHighlight1": "60 AI-posts / maand",
    "starterHighlight2": "1 merk · 2 platformen",
    "starterHighlight3": "1 teamlid",
    "starterHighlight4": "Basis analytics",
    "proHighlight1": "300 AI-posts / maand",
    "proHighlight2": "5 merken · alle platformen",
    "proHighlight3": "3 teamleden",
    "proHighlight4": "fal.ai beeldgeneratie",
    "proHighlight5": "50 reels / maand",
    "proHighlight6": "Volledige analytics + prime time",
    "agencyHighlight1": "Ongelimiteerd posts + merken",
    "agencyHighlight2": "Ongelimiteerd teamleden",
    "agencyHighlight3": "Toegang tot Meta Ads",
    "agencyHighlight4": "100 reels / maand",
    "agencyHighlight5": "Thought-leader ads",
    "agencyHighlight6": "Priority support",
    "detailsTitle": "Facturatiegegevens",
    "detailsSubtitle": "Bedrijfsgegevens voor je facturen — BTW-nummer, KVK en factuuradres.",
    "companyName": "Bedrijfsnaam",
    "billingEmail": "Factuur-e-mailadres",
    "vatNumber": "BTW-nummer",
    "registrationNumber": "KVK-nummer",
    "addressLine1": "Adres",
    "addressLine2": "Adresregel 2",
    "postalCode": "Postcode",
    "city": "Plaats",
    "countryCode": "Landcode",
    "detailsSaved": "Facturatiegegevens opgeslagen",
    "detailsSaveFailed": "Facturatiegegevens opslaan mislukt",
    "detailsLastSaved": "Laatst opgeslagen {{date}}",
    "customerType": "Type klant",
    "customerType_business": "Zakelijk",
    "customerType_private": "Particulier",
    "detailsRequiredForCheckout": "Vul eerst je facturatiegegevens hieronder in voordat je upgradet.",
    "invoicesTitle": "Facturen",
    "invoicesSubtitle": "Facturen voor je abonnement en extra tegoed, verstuurd naar je factuur-e-mailadres.",
    "invoiceDate": "Datum",
    "invoiceDescription": "Omschrijving",
    "invoiceAmount": "Bedrag",
    "invoiceStatus": "Status",
    "invoiceCreated": "Verstuurd",
    "invoicePending": "In behandeling",
    "invoiceView": "Bekijken"
  },
  "cadence": {
    "title": "Contentcadans",
    "subtitle": "Automatisch postgeneratieschema voor je merken",
    "viewOnly": "Alleen-lezen.",
    "viewOnlyDescription": "Alleen de werkruimte-eigenaar kan cadans-instellingen wijzigen. Je kunt wel zien wat voor elk merk is ingesteld.",
    "postsPerWeek": "Posts per week",
    "noCadence": "Geen cadans",
    "onTrack": "Op schema",
    "needsAttention": "Vraagt aandacht",
    "schedule": "Schema",
    "board": "Bord",
    "list": "Lijst",
    "addPlatform": "{{platform}} toevoegen",
    "nextGeneration": "Volgende generatie",
    "recentActivity": "Recente activiteit",
    "mondayInfo": "Cadence-drafts worden automatisch om 06:00 gegenereerd — afhankelijk van de generatiemodus boven (Wekelijks of Dagelijks). Het schema bepaalt wanneer elke post wordt gepubliceerd. Drafts komen in de",
    "noCadenceTooltip": "Geen actieve cadans — Merkflow genereert nog geen posts voor dit merk.",
    "onTrackTooltip": "Op schema: {{fillPct}}% van het maanddoel ({{actual}} van {{expected}} posts) is al onderweg.",
    "needsAttentionTooltip": "Vraagt aandacht: slechts {{fillPct}}% van het maanddoel ({{actual}} van {{expected}} posts) is tot nu toe gegenereerd. De drempel voor \"op schema\" is 60%.",
    "noPlatforms": "Geen platforms",
    "scheduleHeader": "{{brand}} — schema",
    "platform": "Platform",
    "perWeek": "/week",
    "days": "Dagen",
    "time": "Tijd",
    "active": "Actief",
    "noPlatformsConfigured": "Geen platforms ingesteld.",
    "forApproval": "voor goedkeuring vóór publicatie.",
    "contentDistribution": "Contentverdeling",
    "self": "{{name}} (zelf)",
    "percentTotal": "{{total}}% totaal",
    "mustEqual100": "moet 100% zijn",
    "autoSaves": "Slaat automatisch op",
    "addBrandToDistribution": "+ Merk toevoegen aan verdeling",
    "createBrandFirst": "Maak eerst een merk aan om de cadans in te stellen.",
    "activeCount": "{{count}} actief",
    "postsPerWeekLabel": "Posts / week",
    "postsCount_one": "{{count}} post",
    "postsCount_other": "{{count}} posts",
    "reviewInboxLabel": "Review-inbox",
    "removeCadence": "Cadans verwijderen",
    "mondayAt0600": "Maandag om 06:00",
    "noCadenceSet": "Geen cadans ingesteld",
    "noRecentPosts": "Geen recente posts.",
    "justNow": "zojuist",
    "viewReviewInbox": "Review-inbox openen →",
    "boardBrandSummary_one": "{{count}} merk · {{posts}} posts / week",
    "boardBrandSummary_other": "{{count}} merken · {{posts}} posts / week",
    "noBrandsForPlatform": "Nog geen merken die {{platform}}-content genereren.",
    "noCadencesConfigured": "Nog geen cadans ingesteld. Ga naar de Schedule-weergave om er een toe te voegen.",
    "timingHint": "De cron draait elke dag om 06:00. De dagen/tijden per platform hier bepalen wanneer elke post wordt gepubliceerd — wanneer ze gegenereerd worden hangt af van de modus hieronder. Klik \"Genereer nu\" om direct te testen.",
    "modeTitle": "Generatiemodus",
    "modeSubtitle": "Hoe en wanneer cadence-drafts gegenereerd worden voor deze workspace.",
    "modeWeekly": "Wekelijkse batch",
    "modeWeeklyDescription": "Alle drafts van de week worden maandag 06:00 gegenereerd.",
    "modeWeeklyTooltip": "Maandag 06:00 produceert alle drafts voor elke voorkeursdag van de week in één batch. Je krijgt een golf pending posts aan het begin van de week en hebt tot het geplande tijdstip per post om te reviewen.",
    "modeDaily": "Dagelijks, op elke voorkeursdag",
    "modeDailyDescription": "Eén draft per cadence op de geplande dag om 06:00.",
    "modeDailyTooltip": "Op elke voorkeursdag om 06:00 wordt alleen de draft voor die dag gegenereerd. Drafts voelen frisser (kunnen inspelen op actuele gebeurtenissen) maar het reviewvenster krimpt tot enkele uren voor publicatietijd.",
    "advanced": "Geavanceerd",
    "contentTypesLabel": "Contenttypes",
    "contentTypesHint": "Kies welke post-invalshoeken deze cadence afwisselt. Niets selecteren = alle 6 (standaard).",
    "themeLabel": "Terugkerend thema",
    "themePlaceholder": "bijv. dit kwartaal richten we ons op AI-gedreven logistiek",
    "themeHint": "Optioneel. Wordt in het AI-prompt geïnjecteerd als focusgebied wanneer het bij de post past.",
    "runNow": "Genereer nu",
    "runNowTooltip": "Genereer de drafts van deze week meteen — omzeilt de maandag 06:00 cron",
    "runNowSuccess_one": "{{count}} post toegevoegd aan Beoordelen",
    "runNowSuccess_other": "{{count}} posts toegevoegd aan Beoordelen",
    "runNowFailed": "Mislukt — controleer logs"
  },
  "usage": {
    "title": "Gebruik",
    "subtitle": "Bekijk je Anthropic- en fal.ai-uitgaven en tokenverbruik deze maand.",
    "subtitleNew": "Wat je deze maand betaalt, wat je hebt gebruikt en wat je nog over hebt.",
    "postsGenerated": "Gegenereerde posts",
    "imagesGenerated": "Gegenereerde afbeeldingen",
    "reelsGenerated": "Gegenereerde reels",
    "thisMonth": "Deze maand",
    "ofLimit": "van {{limit}}",
    "unlimited": "Onbeperkt",
    "resets": "Reset {{date}}",
    "aiPosts": "AI-posts",
    "images": "Afbeeldingen",
    "reels": "Reels",
    "costThisMonth": "Deze maand (€)",
    "anthropicCalls": "Anthropic-calls",
    "falAiCalls": "fal.ai-calls",
    "tokensUsed": "Tokens verbruikt",
    "byModel": "Per model",
    "noUsageYet": "Nog geen gebruik deze maand",
    "model": "Model",
    "requests": "Verzoeken",
    "tokens": "Tokens",
    "costEuro": "Kosten (€)",
    "spend": {
      "title": "Deze maand",
      "subtitle": "Plan plus extra's bij elkaar.",
      "plan": "Plan",
      "topups": "Top-ups",
      "total": "Totaal",
      "totalSubtitle": "Plan plus top-ups deze maand.",
      "month": "maand",
      "free": "Inclusief in je proefperiode",
      "complimentary": "Cadeau (door admin toegekend)",
      "renewsOn": "Verlengt op {{date}}",
      "renewsMonthly": "Verlengt maandelijks",
      "trialEnds": "Proefperiode eindigt {{date}}",
      "packsCount_one": "{{count}} pakket gekocht",
      "packsCount_other": "{{count}} pakketten gekocht"
    },
    "utilization": {
      "title": "Plan-gebruik",
      "subtitle": "Wat je deze maand hebt verbruikt ten opzichte van je plan-limieten.",
      "unlimitedCount": "{{used}} (onbeperkt)",
      "atCapBuy": "Limiet bereikt — koop extra capaciteit",
      "nearCapBuy": "Bijna op — top-up?"
    },
    "topups": {
      "title": "Top-up balans",
      "subtitle": "Extra's die je hebt gekocht. Oudere pakketten worden eerst verbruikt.",
      "buyMore": "Meer kopen",
      "empty": "Nog geen top-ups gekocht. Als je tijdens de maand je plan-limiet bereikt, kun je hier extra capaciteit kopen.",
      "fullyUsed": "Volledig verbruikt",
      "neverExpires": "—",
      "colPack": "Pakket",
      "colPaid": "Betaald",
      "colRemaining": "Resterend",
      "colPurchased": "Gekocht",
      "colExpires": "Vervalt"
    },
    "trend": {
      "title": "Activiteit (laatste 30 dagen)",
      "subtitle": "Wat je dag voor dag hebt gegenereerd.",
      "empty": "Geen activiteit in de laatste 30 dagen."
    },
    "resource": {
      "posts": "Posts",
      "images": "Afbeeldingen",
      "reels_no_audio": "Reels (zonder audio)",
      "reels_with_audio": "Reels (met audio)",
      "carousels": "Carousels",
      "brands": "Merken",
      "platforms": "Verbonden platformen",
      "team_members": "Teamleden",
      "api_keys": "API-sleutels"
    }
  },
  "onboarding": {
    "title": "Vertel ons over {{brand}}",
    "whatBringsYou": "Wat brengt je hier?",
    "stepCount": "Stap {{step}} van 3",
    "stepCountBeta": "Eén korte stap",
    "competitors": {
      "title": "Ken je concurrenten?",
      "subtitle": "Voeg tot 3 concurrenten toe zodat we je AI-zichtbaarheid vanaf dag één kunnen vergelijken.",
      "skip": "Overslaan",
      "save": "Opslaan & doorgaan",
      "name": "Naam concurrent",
      "url": "Website (optioneel)"
    },
    "pickOptionDescription": "Kies wat het best bij je situatie past. Je kunt dit later wijzigen.",
    "solo": "Solo / maker",
    "soloDescription": "Persoonlijk merk, side project",
    "business": "Bedrijf",
    "businessDescription": "Eén bedrijf, meerdere kanalen",
    "agencyLabel": "Agency",
    "agencyDescription": "Beheert merken voor klanten",
    "setupWorkspace": "Stel je werkruimte in",
    "setupDescription": "Maak je eerste werkruimte aan en voeg een merk toe.",
    "beta": {
      "title": "Vertel ons over je merk",
      "subtitle": "Je bent erbij. Geef je merknaam en website door, dan regelen wij de rest."
    },
    "workspaceName": "Naam werkruimte",
    "workspaceNamePlaceholder": "Mijn werkruimte",
    "firstBrandName": "Naam eerste merk",
    "brandNamePlaceholder": "Mijn merk",
    "brandWebsite": "Merkwebsite",
    "websitePlaceholder": "https://voorbeeld.nl",
    "finishSetup": "Voltooien",
    "whatYouDo": "Wat doe je?",
    "idealCustomer": "Wie is je ideale klant?",
    "recentWins": "Recente successen of projecten",
    "tone": "Hoe zou je je toon omschrijven?",
    "language": "Taal van posts",
    "postVoice": "Stem van de post",
    "founderName": "Naam oprichter",
    "extraContext": "Nog iets anders?",
    "skipForNow": "Overslaan",
    "saveAndCrawl": "Opslaan en crawlen starten",
    "languageNl": "Nederlands",
    "languageEn": "Engels",
    "languageBoth": "Beide",
    "voiceFounder": "Als oprichter (ik / wij)",
    "voiceBrand": "Als merk",
    "choosePlan": "Kies je abonnement",
    "trialActiveMessage": "Je proefperiode van {{days}} dagen is actief. Upgraden kan altijd via facturatie.",
    "continueToDashboard": "Verder naar dashboard"
  },
  "invitations": {
    "youreInvited": "Je bent uitgenodigd",
    "inviteMessage": "{{inviterName}} heeft je uitgenodigd om lid te worden van {{workspaceName}} op Merkflow.",
    "expires": "Verloopt",
    "acceptInvitation": "Uitnodiging accepteren",
    "signInToAccept": "Log in om te accepteren",
    "signInRedirect": "Je komt direct na inloggen hier weer terug.",
    "notFound": "Uitnodiging niet gevonden",
    "notFoundDescription": "We konden deze uitnodiging niet vinden. Controleer de link of vraag degene die je uitnodigde om een nieuwe te sturen.",
    "expired": "Deze uitnodiging is verlopen",
    "expiredDescription": "De link is niet meer geldig. Vraag de werkruimte-eigenaar om een nieuwe uitnodiging.",
    "alreadyAccepted": "Al geaccepteerd",
    "alreadyAcceptedDescription": "Deze uitnodiging is al geaccepteerd. Log in en wissel van werkruimte via de bovenbalk.",
    "acceptFailed": "Uitnodiging accepteren mislukt",
    "joining": "Toetreden…"
  },
  "ads": {
    "title": "Meta Marketing",
    "subtitle": "Maak en beheer campagnes op Facebook en Instagram.",
    "newCampaign": "Nieuwe campagne",
    "createCampaign": "Campagne aanmaken",
    "noCampaigns": "Start je eerste Meta-campagne",
    "noCampaignsDescription": "Maak gerichte advertenties op Facebook en Instagram met je bestaande berichten of nieuwe creatives.",
    "campaignNotFound": "Campagne niet gevonden",
    "backToList": "Terug naar campagnes",
    "viewDetails": "Bekijken",
    "dailyBudget": "Dagbudget",
    "dailyTrend": "Uitgaven per dag (laatste 30 dagen)",
    "noDailyData": "Nog geen dagelijkse data — de synchronisatie draait elke nacht om 04:30.",
    "syncsNightly": "Data wordt elke nacht ververst (04:30 UTC)",
    "notYetSynced": "Inzichten worden vannacht voor het eerst gesynchroniseerd.",
    "reconnectTitle": "Bijgewerkte Meta-rechten nodig",
    "reconnectMeta": "Je Meta-verbinding heeft de nieuwe ads-rechten nodig om advertenties te beheren. Verbind opnieuw om campagnebeheer in te schakelen.",
    "reconnect": "Meta opnieuw verbinden",
    "budgetHelper": "Dit budget wordt rechtstreeks door Meta in rekening gebracht op je advertentieaccount. Merkflow brengt geen kosten in rekening voor advertentie-uitgaven.",
    "deleteConfirmTitle": "Campagne verwijderen?",
    "deleteConfirmBody": "Dit verwijdert de campagne, advertentiesets en creatives in Merkflow. Bij Meta blijft hij actief tot je hem daar ook stopt.",
    "effectiveStatusTooltip": "Status zoals Meta die nu rapporteert: {{status}}",
    "effectiveStatusDrift": "was anders in Merkflow — net gesynchroniseerd",
    "promoteThisPost": "Promoot dit bericht",
    "promote": {
      "title": "Bericht promoten",
      "subtitle": "Boost dit {{platform}}-bericht naar een breder publiek",
      "budgetLabel": "Dagbudget",
      "perDay": "per dag",
      "durationLabel": "Looptijd",
      "days": "dagen",
      "countriesLabel": "Landen",
      "ageRange": "Leeftijdsbereik",
      "paused": "De campagne wordt aangemaakt in concept. Op de detailpagina kan je hem reviewen en pas dan publiceren — er wordt nog geen geld uitgegeven.",
      "boost": "Boosten",
      "creating": "Aanmaken…",
      "genericError": "Promoten mislukt. Controleer je Meta-verbinding en probeer opnieuw."
    },
    "promoteGate": {
      "PROMOTE_POST_NOT_PUBLISHED": "Alleen gepubliceerde berichten kunnen geboost worden.",
      "PROMOTE_POST_UNSUPPORTED_PLATFORM": "Boost is alleen beschikbaar voor Facebook en Instagram. LinkedIn-berichten kun je niet boosten via Merkflow.",
      "PROMOTE_POST_NO_EXTERNAL_ID": "Dit bericht is niet via Meta gepubliceerd, dus er is geen Meta-bericht-id om te boosten.",
      "PROMOTE_POST_NO_COUNTRIES": "Kies minstens één land om naar te targeten.",
      "PUBLISH_NO_BUDGET": "Stel een positief dagbudget in.",
      "MISSING_ADS_SCOPE": "Je Meta-verbinding heeft de nieuwe advertentierechten nodig. Verbind Meta opnieuw vanaf de verbindingenpagina."
    },
    "steps": {
      "objective": "Doel",
      "budget": "Budget",
      "audience": "Doelgroep",
      "creative": "Creative"
    },
    "objectives": {
      "awareness": "Merkbekendheid",
      "awarenessDesc": "Laat meer mensen je merk zien",
      "traffic": "Verkeer",
      "trafficDesc": "Stuur mensen naar je website",
      "engagement": "Betrokkenheid",
      "engagementDesc": "Krijg meer likes, reacties en shares",
      "conversions": "Conversies",
      "conversionsDesc": "Laat mensen een actie uitvoeren op je website"
    },
    "status": {
      "active": "Actief",
      "draft": "Concept",
      "paused": "Gepauzeerd",
      "completed": "Afgerond"
    },
    "metrics": {
      "spend": "Uitgaven",
      "impressions": "Vertoningen",
      "reach": "Bereik",
      "clicks": "Klikken",
      "cpm": "CPM",
      "ctr": "CTR"
    },
    "actions": {
      "publish": "Publiceren",
      "pause": "Pauzeren",
      "delete": "Verwijderen"
    },
    "ctas": {
      "LEARN_MORE": "Meer informatie",
      "SHOP_NOW": "Nu winkelen",
      "SIGN_UP": "Aanmelden",
      "CONTACT_US": "Neem contact op",
      "DOWNLOAD": "Downloaden"
    },
    "wizard": {
      "title": "Nieuwe Meta-campagne",
      "creating": "Aanmaken…",
      "create": "Campagne aanmaken",
      "nameLabel": "Naam van de campagne",
      "namePlaceholder": "Bijv. Voorjaarsactie 2026",
      "brandLabel": "Merk",
      "brandNone": "Geen specifiek merk",
      "brandHint": "Het merk dat aan deze campagne gekoppeld is voor rapportages en filtering.",
      "objectiveLabel": "Wat wil je bereiken?",
      "dailyBudgetLabel": "Dagbudget",
      "perDay": "per dag",
      "startDate": "Startdatum",
      "endDate": "Einddatum",
      "endDateHint": "Laat leeg om continu te draaien",
      "countriesLabel": "Landen",
      "countriesHint": "ISO-codes gescheiden door komma's (NL, BE, DE)",
      "ageRange": "Leeftijdsbereik",
      "platforms": "Platformen",
      "headlineLabel": "Kop",
      "headlinePlaceholder": "Korte, krachtige zin",
      "descriptionLabel": "Beschrijving",
      "descriptionPlaceholder": "Maximaal 125 tekens — de tekst onder de kop",
      "imageUrlLabel": "Afbeelding-URL",
      "ctaLabel": "Knop",
      "preview": "Voorbeeld",
      "previewEmptyHeadline": "Vul een kop in om een voorbeeld te zien",
      "missingScopeError": "Je Meta-verbinding heeft geen advertentierechten meer. Verbind Meta opnieuw vanaf de verbindingenpagina.",
      "genericError": "Aanmaken mislukt. Probeer het opnieuw of controleer je Meta-verbinding."
    },
    "publishGate": {
      "generic": {
        "title": "Publiceren is nog niet mogelijk",
        "body": "Controleer de configuratie van de campagne voordat je publiceert."
      },
      "PUBLISH_NOT_SYNCED": {
        "title": "Campagne nog niet gesynchroniseerd met Meta",
        "body": "Deze campagne is niet aangemaakt bij Meta. Maak hem opnieuw aan via de wizard — Meta kreeg waarschijnlijk een fout bij de eerste poging."
      },
      "PUBLISH_NO_BUDGET": {
        "title": "Stel een dagbudget in",
        "body": "Meta kan geen advertenties leveren zonder dagbudget. Voeg een budget toe en publiceer opnieuw."
      },
      "PUBLISH_NO_AD_SETS": {
        "title": "Voeg minstens één advertentieset toe",
        "body": "Een campagne zonder advertentiesets kan niet draaien. Open de campagne in Meta Ads Manager om een set toe te voegen — of maak de campagne opnieuw aan via de wizard."
      },
      "PUBLISH_NO_CREATIVES": {
        "title": "Voeg minstens één creative toe",
        "body": "Er zijn advertentiesets maar geen creatives. Voeg een afbeelding of bericht toe voordat je publiceert."
      },
      "PUBLISH_BILLING_NOT_CONFIGURED": {
        "title": "Stel eerst je Meta-betaalmethode in",
        "body": "Je Meta-advertentieaccount heeft nog geen creditcard of betaalmethode. Open Meta Business Manager → Facturering en voeg er een toe — Merkflow brengt zelf geen advertentiekosten in rekening, alles gaat via Meta."
      },
      "PUBLISH_AD_ACCOUNT_DISABLED": {
        "title": "Je Meta-advertentieaccount is gedeactiveerd",
        "body": "Meta heeft je advertentieaccount gepauzeerd of beperkt. Open Meta Business Manager om de status te zien en in beroep te gaan."
      }
    }
  },
  "calendar": {
    "title": "Agenda",
    "subtitle": "Echte posts en geprojecteerde cadansslots voor deze maand",
    "prevMonth": "Vorige maand",
    "nextMonth": "Volgende maand",
    "published": "Gepubliceerd",
    "scheduledDraft": "Ingeplande draft",
    "cadenceSlot": "Cadansslot (wordt gegenereerd)",
    "nothingScheduled": "Niets gepland of geprojecteerd voor deze dag.",
    "projectedCadenceSlots": "Geprojecteerde cadansslots",
    "willGeneratePost": "Merkflow genereert een {{platform}}-post voor {{brandName}} om {{time}}",
    "cadenceSlotTitle": "Cadansslot — {{platform}}",
    "scheduled": "Ingepland"
  },
  "discover": {
    "title": "Ontdekken",
    "subtitle": "Trending topics, hashtags en contentideeën voor je merken.",
    "upgrade": {
      "title": "Trending content is een betaalde functie",
      "body": "Ontdekken laat wekelijkse trending topics, hashtags en AI-gegenereerde contentideeën zien per merk. Beschikbaar op abonnementen waar trending content discovery bij zit."
    },
    "staleData": "Laatst bijgewerkt meer dan 24u geleden — klik op Vernieuwen om te updaten.",
    "allBrands": "Alle merken",
    "updatedTime": "Bijgewerkt {{time}}",
    "sourceLabel": "Bron: {{source}}",
    "refreshing": "Vernieuwen...",
    "trendingHashtags": "Trending hashtags",
    "noTrendingData": "Nog geen trending data. Voeg merken met onboarding-profielen toe en klik op Vernieuwen.",
    "clickToCopy": "Klik om te kopiëren",
    "contentIdeas": "Contentideeën",
    "noIdeas": "Nog geen contentideeën",
    "noIdeasDescription": "Vul je merk-onboardingprofielen in en klik op Vernieuwen om AI-gegenereerde contentsuggesties te krijgen.",
    "marketIntelligence": "Marktinformatie",
    "marketIntelligenceDescription": "De concurrenten waar je tegen aanloopt en hoe AI-zoekmachines hen naast jou zien.",
    "viewFullAnalysis": "Volledige analyse bekijken",
    "generatePost": "Post genereren →"
  },
  "storyline": {
    "title": "Verhaallijnen",
    "subtitle": "Narratieve bogen die toewerken naar een doel — productlanceringen, campagnes, aankondigingen.",
    "new": "Nieuwe verhaallijn",
    "allBrands": "Alle merken",
    "noStorylines": "Nog geen verhaallijnen",
    "emptyDescription": "Maak een verhaallijn om een narratieve boog te plannen — zoals een aftelling tot productlancering of een campagneopbouw.",
    "deleteConfirm": "Deze verhaallijn archiveren? Posts worden losgekoppeld, maar niet verwijderd.",
    "delete": "Verhaallijn archiveren",
    "permanentDelete": "Definitief verwijderen",
    "permanentDeleteTitle": "Deze verhaallijn definitief verwijderen?",
    "permanentDeleteConfirm": "Dit kan niet ongedaan gemaakt worden. Gekoppelde posts verliezen hun verhaallijn-referentie maar blijven gepubliceerd.",
    "target": "Doel: {{date}}",
    "noDate": "Geen datum",
    "noContentYet": "Nog geen content",
    "mediaAttached": "📎 {{type}} bijgevoegd",
    "daysLeft_one": "{{count}} dag over",
    "daysLeft_other": "{{count}} dagen over",
    "postsProgress": "{{published}}/{{total}} posts",
    "rebuildPosts": "Posts herbouwen",
    "publishedPosts_one": "{{published}} / {{total}} post gepubliceerd",
    "publishedPosts_other": "{{published}} / {{total}} posts gepubliceerd",
    "targetDays": "Doel: {{date}} ({{days}} dagen)",
    "noPostsYet": "Nog geen posts in deze verhaallijn. De boog wordt mogelijk nog gegenereerd.",
    "openInReview": "Openen in beoordeling →",
    "notFound": "Verhaallijn niet gevonden.",
    "stepN": "Stap {{step}} van 3",
    "brand": "Merk",
    "name": "Naam verhaallijn",
    "namePlaceholder": "bijv. Aftelling productlancering",
    "goal": "Doel (optioneel)",
    "goalPlaceholder": "bijv. Bouw spanning op voor de lancering van onze nieuwe bidding engine",
    "targetDate": "Streefdatum",
    "platforms": "Platforms",
    "generateArc": "Boog genereren →",
    "generatingArc": "Boog genereren...",
    "proposedArc": "Voorgestelde boog — {{count}} posts",
    "reviewSummary": "Samenvatting bekijken →",
    "confirm": "Bevestigen en aanmaken",
    "confirmDescription_one": "{{count}} post wordt aangemaakt en toegevoegd aan je beoordelingsinbox.",
    "confirmDescription_other": "{{count}} posts worden aangemaakt en toegevoegd aan je beoordelingsinbox."
  },
  "blog": {
    "titleLabel": "Blogposts",
    "subtitle": "AI-gegenereerde blogposts voor de WordPress-sites van je merken. Keur goed om te publiceren.",
    "write": "Blog schrijven",
    "generate": "Blog genereren",
    "allBrands": "Alle merken",
    "allStatuses": "Alle statussen",
    "pendingReview": "Wacht op beoordeling",
    "approved": "Goedgekeurd",
    "rejected": "Afgewezen",
    "showRejected": "Afgewezen tonen",
    "noPostsYet": "Nog geen blogposts",
    "emptyDescription": "Blogposts worden wekelijks gegenereerd voor merken met een WordPress-verbinding. Verbind WordPress in je merkinstellingen om te beginnen.",
    "words": "{{count}} woorden",
    "preview": "Voorbeeld",
    "hideContent": "Inhoud verbergen",
    "showContent": "Volledige inhoud tonen",
    "approvePublish": "Goedkeuren & publiceren",
    "reject": "Afwijzen",
    "regenerate": "Opnieuw genereren",
    "fieldTitle": "Titel",
    "focusKeyword": "Focus-keyword",
    "focusKeywordExample": "bijv. social media management",
    "metaDescription": "Meta-omschrijving",
    "metaDescriptionPlaceholder": "SEO-omschrijving (160 tekens)",
    "content": "Inhoud",
    "titlePlaceholder": "Titel van de blogpost...",
    "contentPlaceholder": "Begin met schrijven... Gebruik de toolbar voor koppen, lijsten, afbeeldingen.",
    "editorPlaceholder": "Begin met schrijven van je blogpost...",
    "heading2": "Kop 2",
    "heading3": "Kop 3",
    "bulletList": "Opsomming",
    "numberedList": "Genummerde lijst",
    "addLink": "Link toevoegen",
    "uploadImage": "Afbeelding uploaden",
    "wordCount": "{{count}} woorden",
    "generateBlogPost": "Blogpost genereren",
    "generateSubtitle": "AI schrijft een SEO-geoptimaliseerde blogpost met kennis over je merk",
    "topic": "Onderwerp (optioneel)",
    "topicPlaceholder": "Laat leeg en de AI kiest op basis van merkkennis",
    "customInstructions": "Extra instructies (optioneel)",
    "customInstructionsHelper": "Bijvoorbeeld: schrijfstijl, invalshoek, specifieke punten om te behandelen, of doelgroep-nuance.",
    "customInstructionsCharCount": "{{count}} / {{max}}",
    "language": "Taal",
    "languageBothHint": "Dit merk schrijft in beide talen. Kies hier de taal voor déze blogpost.",
    "generateHint": "De AI gebruikt je merk-onboardingprofiel en de gecrawlde kennis om een blogpost van 1000-1500 woorden te schrijven met een SEO-focus-keyword en meta-omschrijving.",
    "writing": "Blogpost schrijven...",
    "generationEta": "30-60 seconden",
    "genFailed": "Genereren mislukt",
    "writeBlogPost": "Blogpost schrijven",
    "writeSubtitle": "Maak een blogpost handmatig aan — klaar om te publiceren naar WordPress",
    "saveFailed": "Opslaan mislukt",
    "saveBlogPost": "Blogpost opslaan",
    "coverImage": "Cover-afbeelding (optioneel)",
    "coverImagePickerCta": "Sleep een afbeelding hierheen of klik om te uploaden",
    "coverImageHint": "Wordt gebruikt als hero-afbeelding op het blog-overzicht. Als je deze overslaat wordt de standaardafbeelding van het merk gebruikt.",
    "coverImageTypeError": "Dat bestand is geen afbeelding.",
    "coverImageUploadFailed": "Upload mislukt — probeer het opnieuw.",
    "coverImageUploadCta": "Uploaden",
    "coverImageGenerateCta": "Genereer met AI",
    "coverImageGenerating": "Cover wordt gegenereerd met fal.ai (~15s)…",
    "coverImageGenerateFailed": "AI-cover genereren mislukt — probeer opnieuw of upload zelf een afbeelding.",
    "shortDescription": "Korte beschrijving (optioneel)",
    "shortDescriptionPlaceholder": "1–2 zinnen die onder de posttitel op het blog-overzicht verschijnen…",
    "shortDescriptionHint": "Overschrijft de automatische samenvatting. Houd het kort — ongeveer 240 tekens.",
    "wordpress": "WordPress",
    "connectToPublish": "Verbind om blogposts te publiceren",
    "disconnectConfirm": "WordPress loskoppelen?",
    "siteUrl": "WordPress site-URL",
    "siteUrlExample": "https://www.merkflow.eu",
    "username": "Applicatie-gebruikersnaam",
    "usernamePlaceholder": "Je WordPress login-gebruikersnaam (niet je weergavenaam)",
    "usernameHint": "Te vinden in WP Admin → Gebruikers → jouw profiel → bovenaan bij Gebruikersnaam",
    "password": "Applicatie-wachtwoord",
    "passwordPlaceholder": "xxxx xxxx xxxx xxxx xxxx xxxx",
    "passwordHint": "WP Admin → Gebruikers → Profiel → Applicatie-wachtwoorden → Nieuw toevoegen. Spaties zijn optioneel — plak het zoals WordPress het toont.",
    "connectionFailed": "Verbinding mislukt",
    "saveVerify": "Opslaan & verifiëren",
    "wpError": {
      "authHeaderStripped": "Je WordPress-server verwijdert de Authorization-header",
      "authHeaderStrippedHelp": "Apache en sommige managed hosts laten de Authorization-header vallen voordat PHP hem kan lezen, waardoor WordPress je verzoek als anoniem ziet. Plak dit in je .htaccess-bestand, boven het '# BEGIN WordPress'-blok, en probeer het opnieuw:",
      "wrongCredentials": "Onjuiste gebruikersnaam of applicatie-wachtwoord",
      "wrongCredentialsHelp": "Gebruik je WordPress login-gebruikersnaam (niet je e-mailadres). Het wachtwoord moet een 24-tekens Applicatie-wachtwoord zijn — niet je gewone login-wachtwoord. Genereer er een via WP Admin → Gebruikers → jouw profiel → Applicatie-wachtwoorden.",
      "notFound": "WordPress REST API niet gevonden op die URL",
      "notFoundHelp": "Zorg dat de site-URL begint met https:// en naar je WordPress-homepage wijst (geen /wp-admin, geen trailing slash). Als REST uitstaat door een beveiligingsplugin, zet hem weer aan voor ingelogde gebruikers.",
      "pluginBadToken": "De Merkflow-plugin heeft dit token afgewezen",
      "pluginNotInstalled": "Merkflow-plugin niet gevonden op die site",
      "pluginInvalidToken": "Token lijkt te kort",
      "pluginUnknown": "Kan de Merkflow-plugin niet bereiken"
    },
    "connection": {
      "chooserSubtitle": "Kies hoe Merkflow met je WordPress-site praat",
      "prosLabel": "Voordelen",
      "consLabel": "Nadelen",
      "pluginTitle": "Merkflow-plugin",
      "pluginSubtitle": "Tokenverbinding met alle features",
      "pluginBestFor": "Geschikt voor: AI-vindbaarheid, alle features",
      "pluginPro1": "Echte /llms.txt op je site root, plain text",
      "pluginPro2": "Blogposts en cover-afbeeldingen publiceren",
      "pluginPro3": "Geen WordPress-account of wachtwoord nodig",
      "pluginCon1": "Eenmalige plugin-installatie (zip-upload + activeren in WP)",
      "pluginCon2": "Plugin moet actief blijven — uitschakelen verbreekt de verbinding",
      "pluginButton": "Verbind via plugin",
      "pluginBadge": "Plugin",
      "pluginBadgeTooltip": "Verbonden via de Merkflow-plugin — alle features beschikbaar.",
      "apiKeyTitle": "Applicatie-wachtwoord",
      "apiKeySubtitle": "Verbinden via een WordPress Applicatie-wachtwoord",
      "apiKeyBestFor": "Geschikt voor: alleen blog publiceren, geen plugin mogelijk",
      "apiKeyPro1": "Werkt op elke WordPress-site — geen plugin nodig",
      "apiKeyPro2": "Standaard WordPress-mechanisme, fijnmazige rechten",
      "apiKeyPro3": "Direct in te trekken vanuit WP-gebruikersprofiel",
      "apiKeyCon1": "Geen echte /llms.txt — AI-vindbaarheid beperkt",
      "apiKeyCon2": "Sommige hosts strippen de auth-header (.htaccess fix nodig)",
      "apiKeyButton": "Verbind via API-key",
      "apiKeyBadge": "API-key",
      "apiKeyBadgeTooltip": "Verbonden via WordPress Applicatie-wachtwoord — llms.txt is niet beschikbaar in deze modus.",
      "apiKeyTradeoffTooltip": "WordPress staat het niet toe om via API een echte /llms.txt te plaatsen. Gebruik de Merkflow-plugin als AI-vindbaarheid telt.",
      "apiKeyTradeoffTitle": "Let op — beperkte modus",
      "apiKeyTradeoffBody": "Met een Applicatie-wachtwoord kun je blogposts publiceren, maar geen geldige /llms.txt op je site root. Schakel over naar plugin-modus als AI-vindbaarheid een doel is.",
      "installSteps": "Installeer eerst de Merkflow-plugin",
      "installStep1": "Download de plugin van je Merkflow-team of bouw vanaf merkflow-wp-plugin/",
      "installStep2": "WP Admin → Plugins → Nieuwe plugin → Plugin uploaden → Activeren",
      "installStep3": "Instellingen → Merkflow → Genereer token, plak hieronder",
      "tokenLabel": "Verbindingstoken",
      "tokenPlaceholder": "Plak het token dat WP Admin toonde",
      "tokenHint": "Eenmalig getoond na 'Genereer token' in WP Admin → Instellingen → Merkflow. Genereer een nieuwe als je hem kwijt bent — dat maakt de oude ongeldig.",
      "testButton": "Test verbinding",
      "testOk": "Plugin bereikbaar, token geaccepteerd",
      "testFailed": "Test mislukt",
      "saveButton": "Opslaan & verbinden"
    }
  },
  "blogAnalytics": {
    "noDataYet": "Nog geen blogverkeer",
    "noDataHint": "De WP-plugin verzamelt paginabezoekstatistieken zodra bezoekers op een blogartikel landen. Synchronisatie draait dagelijks om 03:30 UTC.",
    "totalViews": "Totaal weergaven",
    "totalViews30d": "Weergaven (laatste 30 dagen)",
    "uniqueVisitors": "unieke bezoekers",
    "aiTrafficPct": "Aandeel AI-verkeer",
    "aiTraffic": "AI-verkeer",
    "aiVisits": "bezoeken vanuit AI-assistenten",
    "topPost": "Best presterende artikel",
    "views": "weergaven",
    "noPostsYet": "Nog geen artikelen geanalyseerd",
    "tabHeroTitle": "Blogweergaven",
    "pickBrandTitle": "Kies een merk",
    "pickBrandHint": "Blogstatistieken zijn per merk. Kies hierboven een merk om de bezoekstatistieken te zien.",
    "postsWithViews": "Artikelen met weergaven",
    "referrerTitle": "Herkomst van verkeer",
    "deviceTitle": "Apparaten",
    "topPostsTitle": "Topartikelen",
    "latestDayHint": "Laatste dag in periode",
    "postRef": "Artikel #{{id}}",
    "ref": {
      "ai": "AI-assistenten",
      "search": "Zoekmachines",
      "social": "Social",
      "direct": "Direct",
      "internal": "Intern",
      "other": "Overig"
    },
    "device": {
      "desktop": "Desktop",
      "mobile": "Mobiel",
      "bot": "Bots"
    }
  },
  "adminPlans": {
    "marketingCopy": "Marketingtekst",
    "nameEn": "Naam (EN)",
    "nameNl": "Naam (NL)",
    "taglineEn": "Tagline (EN)",
    "taglineNl": "Tagline (NL)",
    "title": "Plannen",
    "subtitle": "De bron voor limieten, prijzen en feature-flags per abonnement. De Merkflow-app handhaaft deze direct — www.merkflow.eu/pricing toont alleen wat je hier instelt.",
    "sourceOfTruth": "Dit is de bron",
    "sourceOfTruthBody": "Deze pagina bepaalt elk limiet, elke prijs en elke feature-flag voor de Merkflow-app. De WordPress-prijspagina leest diezelfde waarden via /api/public/plans en toont ze — ze wijken nooit af van wat je hier instelt.",
    "livePreviewLabel": "Live voorbeeld",
    "livePreviewLink": "www.merkflow.eu/pricing ↗",
    "cacheLoadedAt": "Cache geladen {{time}}",
    "notPublic": "Niet openbaar",
    "saving": "opslaan",
    "monthlyPriceEur": "Maandprijs (EUR)",
    "priceCaption": "Alleen voor nieuwe abonnees. Bestaande abonnees houden hun huidige prijs tot ze wisselen van plan (Mollie-abonnementen kunnen het bedrag niet aanpassen).",
    "trialDurationDays": "Proefperiode",
    "daysSuffix": "dagen",
    "trialDurationCaption": "Opgeslagen in system_settings.trial_duration_days. Wijzigen werkt door voor nieuwe aanmeldingen + de trial-chip op /pricing. Lopende proefperioden behouden hun reeds vastgestelde einddatum.",
    "aiModelTier": "AI-model niveau",
    "aiModelHaiku": "Haiku (snel, goedkoop)",
    "aiModelSonnet": "Sonnet (gebalanceerd)",
    "aiModelOpus": "Opus (premium)",
    "limitsSection": "Limieten",
    "featuresSection": "Functies",
    "limitLabelWorkspaces": "Workspaces",
    "limitLabelBrandsPerWorkspace": "Merken / workspace",
    "limitLabelPlatforms": "Platforms",
    "limitLabelTeamMembers": "Teamleden",
    "limitLabelApiKeys": "API-sleutels",
    "limitLabelPostsPerMonth": "Posts / maand",
    "limitLabelCarouselsPerMonth": "Carrousels / maand",
    "limitLabelImagesPerMonth": "Afbeeldingen / maand",
    "unlimited": "Onbeperkt",
    "unlimitedClickToSet": "Klik om een numeriek limiet in te stellen",
    "numericSetToUnlimited": "Zet op onbeperkt",
    "loadingState": "Plan-configuratie wordt geladen…",
    "loadError": "Plan-configuratie niet geladen. {{message}}",
    "public": "Openbaar",
    "visibilityHidePricing": "Verberg van openbare prijspagina",
    "visibilityShowPricing": "Toon op openbare prijspagina",
    "limitLabelReelsNoAudio": "Reels / maand (zonder audio)",
    "limitLabelReelsWithAudio": "Reels met audio / maand",
    "tabTiers": "Abonnementen",
    "tabTopups": "Top-ups",
    "recommendation": {
      "openLabel": "Aanbeveling bekijken",
      "deprecated": "Verouderd",
      "inactive": "Inactief",
      "recommendedTiers": "Aanbevolen voor",
      "reasoning": "Waarom",
      "recommendedFor": "Aanbevolen voor {{tier}}",
      "noTierEntry": "Geen specifieke aanbeveling voor {{tier}}",
      "allTiers": "Alle tiers"
    },
    "warnings": {
      "healthy": "Configuratie ziet er gezond uit",
      "dismiss": "Negeren",
      "dismissHint": "Verberg deze sessie (nog geen persistente opslag)"
    },
    "cost": {
      "estimated": "Geschatte kosten",
      "perMonth": "/ maand bij limiet",
      "margin": "marge",
      "marginHint": "Marge = (prijs €{{price}} − geschatte kosten) / prijs. Schatting gebruikt eenheidsprijzen uit UnitCosts.kt.",
      "noMargin": "Geen marge (gratis tier)"
    }
  },
  "topup": {
    "pickerTitle": "Meer capaciteit nodig?",
    "pickerSubtitle": "Je hebt je {{limitName}}-limiet deze maand bereikt. Koop er meer bij — geen upgrade nodig.",
    "planLimitTitle": "Plan-limiet bereikt",
    "planLimitSubtitle": "Je {{plan}}-plan bevat niet meer {{limitName}}.",
    "planLimitBody": "Upgrade om meer {{limitName}} vrij te spelen — een top-up dekt dit type limiet niet.",
    "upgradePlan": "Upgrade plan →",
    "processingHint": "Na betaling duurt het ~30 seconden voor de balans zichtbaar wordt. Je ziet een bevestiging op de facturatiepagina.",
    "sectionTitle": "Extra capaciteit",
    "sectionSubtitle": "Gekochte pakken verlopen na 12 maanden. Oudste pak gaat eerst op (FIFO).",
    "requiresPaidPlan": "Extra capaciteit is alleen beschikbaar op een betaald abonnement. Upgrade naar Starter, Pro of Agency om top-ups te kopen.",
    "processingTitle": "Betaling wordt verwerkt",
    "processingBody": "Je balans wordt binnen ongeveer een minuut bijgewerkt zodra Mollie de betaling bevestigt. Niet verversen.",
    "balanceLabel_one": "Je hebt er {{count}} over",
    "balanceLabel_other": "Je hebt er {{count}} over",
    "resourcePosts": "AI-posts",
    "resourcePostsHaiku": "Haiku-posts",
    "resourcePostsSonnet": "Sonnet-posts",
    "resourcePostsOpus": "Opus-posts",
    "resourceImages": "AI-afbeeldingen",
    "resourceReelsNoAudio": "Reels (geen audio)",
    "resourceReelsWithAudio": "Reels met audio",
    "resourceCarousels": "Carrousels",
    "resourceBrands": "Merken",
    "resourcePlatforms": "Platforms",
    "resourceTeamMembers": "Teamleden",
    "resourceApiKeys": "API-sleutels"
  },
  "adminTopups": {
    "loadError": "Kan top-up pakken niet laden. {{message}}",
    "unitsLabel": "Aantal",
    "priceLabel": "Prijs €",
    "unitCostLabel": "Kostprijs €",
    "marginPercent": "marge {{percent}}%",
    "marginOkTooltip": "Boven de 30%-doel — goed.",
    "marginWarnTooltip": "Onder de 30%-margedoel. Verhoog de prijs of verlaag het aantal units om winstgevend te blijven.",
    "groupPostsHaiku": "Posts — Haiku",
    "groupPostsSonnet": "Posts — Sonnet",
    "groupPostsOpus": "Posts — Opus",
    "groupImages": "Afbeeldingen",
    "groupReelsNoAudio": "Reels — zonder audio",
    "groupReelsWithAudio": "Reels — met audio",
    "groupCarousels": "Carrousels"
  },
  "admin": {
    "users": {
      "role": "Rol",
      "access": "Toegang",
      "admin": "Admin",
      "user": "Gebruiker",
      "promote": "Maak admin",
      "promoteTitle": "Promoveren tot admin?",
      "promoteConfirm": "Geef {{email}} volledige platformbeheer­rechten? Hiermee kan deze persoon elke workspace, elke gebruiker en alle factuurinstellingen beheren.",
      "demote": "Adminrechten intrekken",
      "demoteTitle": "Adminrechten intrekken?",
      "demoteConfirm": "Trek de adminrechten van {{email}} in? Deze persoon verliest toegang tot /admin en wordt een gewone gebruiker.",
      "suspend": "Account opschorten",
      "suspendTitle": "Dit account opschorten?",
      "suspendConfirm": "{{email}} opschorten? Deze persoon wordt uitgelogd en kan niet meer inloggen tot je dit weer opheft.",
      "unsuspend": "Opschorting opheffen",
      "lastAdmin": "Kan adminrechten niet intrekken — er moet minstens één admin blijven.",
      "roleUpdated": "Rol bijgewerkt.",
      "roleUpdateFailed": "Bijwerken van rol mislukt.",
      "statusUpdated": "Status bijgewerkt.",
      "statusUpdateFailed": "Bijwerken van status mislukt."
    },
    "inviteLinks": {
      "title": "Uitnodigingslinks",
      "subtitle": "Genereer signup-URLs voor beta-testers. Elke link maakt een workspace op het gekozen plan met plan_override = true.",
      "create": "Link maken",
      "created": "Aangemaakt. URL gekopieerd.",
      "copyUrl": "URL kopiëren",
      "copied": "URL gekopieerd",
      "disable": "Uitschakelen",
      "disabled": "Uitgeschakeld.",
      "disableFailed": "Uitschakelen mislukt.",
      "confirmDisableTitle": "Deze link uitschakelen?",
      "confirmDisableMessage": "Code {{code}} accepteert geen nieuwe inschrijvingen meer. Bestaande accounts blijven werken.",
      "plan": "Plan",
      "maxUsesLabel": "Max aantal aanmeldingen via deze link (leeg = onbeperkt)",
      "maxUsesPlaceholder": "bijv. 10 — laat leeg voor onbeperkt",
      "expiresLabel": "Vervalt (leeg = nooit)",
      "never": "Nooit",
      "stateActive": "Actief",
      "stateExpired": "Verlopen",
      "stateMaxed": "Maximum bereikt",
      "stateDisabled": "Uitgeschakeld",
      "redemptionsTitle": "Inschrijvingen",
      "noRedemptions": "Nog niemand heeft deze link gebruikt.",
      "colCode": "Code",
      "colPlan": "Plan",
      "colUses": "Gebruik",
      "colExpires": "Vervalt",
      "colCreated": "Aangemaakt",
      "colStatus": "Status",
      "colActions": "Acties",
      "empty": {
        "title": "Nog geen uitnodigingslinks",
        "description": "Maak er één om een signup-URL te delen met beta-testers."
      }
    },
    "feedback": {
      "title": "Feedback",
      "subtitle": "Bugs, wensen en vragen die beta-testers indienen.",
      "entriesCount_one": "{{count}} item",
      "entriesCount_other": "{{count}} items",
      "categoryAll": "Alle categorieën",
      "statusNew": "Nieuw",
      "statusAcknowledged": "Bevestigd",
      "statusResolved": "Opgelost",
      "statusWont_fix": "Niet gefixt",
      "statusAll": "Alle",
      "status": "Status",
      "screenshot": "Screenshot",
      "adminNotes": "Admin-notities",
      "updated": "Opgeslagen.",
      "updateFailed": "Bijwerken mislukt.",
      "markResolved": "Opgelost markeren",
      "markedResolved": "Gemarkeerd als opgelost.",
      "delete": "Verwijderen",
      "deleted": "Verwijderd.",
      "deleteFailed": "Verwijderen mislukt.",
      "widgetSection": "Feedbackwidget",
      "widgetOnHint": "Aan — de drijvende feedback-knop is zichtbaar voor iedereen op alle dashboardpagina's.",
      "widgetOffHint": "Uit — de drijvende feedback-knop is voor iedereen verborgen. Inzendingen worden ook server-side geweigerd.",
      "widgetEnabled": "Feedbackwidget aangezet.",
      "widgetDisabled": "Feedbackwidget uitgezet.",
      "toggleFailed": "Kon widget-instelling niet bijwerken.",
      "confirmDeleteTitle": "Deze feedback verwijderen?",
      "confirmDeleteMessage": "Permanent \"{{title}}\" verwijderen? Screenshot blijft in S3 — alleen de DB-rij wordt verwijderd.",
      "descriptionLabel": "Beschrijving",
      "notesPlaceholder": "Interne notities — alleen zichtbaar voor admins.",
      "notFound": "Deze feedback bestaat niet meer.",
      "backToList": "Terug naar feedback",
      "dangerZone": "Gevaarlijke zone",
      "colCategory": "Categorie",
      "colTitle": "Titel",
      "colPage": "Pagina",
      "colStatus": "Status",
      "colSubmitted": "Ingediend",
      "empty": {
        "title": "Nog geen feedback",
        "description": "Inzendingen van beta-testers verschijnen hier. Gebruik de Feedback-knop op dashboardpagina's om er zelf één te sturen."
      }
    },
    "waitlist": {
      "title": "Wachtlijst",
      "subtitle": "Beheer toegangsverzoeken die binnenkomen wanneer registratie gesloten is.",
      "searchPlaceholder": "Zoek op e-mail of naam…",
      "entriesCount_one": "{{count}} verzoek",
      "entriesCount_other": "{{count}} verzoeken",
      "statusPending": "In afwachting",
      "statusApproved": "Goedgekeurd",
      "statusRejected": "Afgewezen",
      "statusAll": "Alle",
      "approve": "Goedkeuren",
      "reject": "Afwijzen",
      "approveSelected_one": "{{count}} verzoek goedkeuren",
      "approveSelected_other": "{{count}} verzoeken goedkeuren",
      "bulkApprove": "Bulk goedkeuren",
      "approveSuccess": "Goedgekeurd. E-mail verstuurd.",
      "approveFailed": "Goedkeuren mislukt.",
      "rejectSuccess": "Afgewezen.",
      "rejectFailed": "Afwijzen mislukt.",
      "bulkApproveSuccess": "Goedkeuringen verwerkt. E-mails verstuurd.",
      "confirmRejectTitle": "Dit verzoek afwijzen?",
      "confirmRejectMessage": "Toegang voor {{email}} afwijzen? Ze krijgen geen melding — ze kunnen later opnieuw aanvragen.",
      "confirmBulkApproveTitle": "Alle geselecteerde goedkeuren?",
      "confirmBulkApproveMessage": "{{count}} verzoeken goedkeuren en elk een goedkeuringsmail sturen?",
      "approvedOn": "Goedgekeurd {{date}}",
      "colEmail": "E-mail",
      "colName": "Naam",
      "colCompany": "Bedrijf",
      "colUseCase": "Use case",
      "colSubmitted": "Ingediend",
      "colStatus": "Status",
      "colActions": "Acties",
      "empty": {
        "title": "Nog geen verzoeken",
        "description": "Wachtlijst-verzoeken verschijnen hier zodra registratie gesloten is en bezoekers het aanvraagformulier invullen."
      }
    },
    "create": {
      "button": "Gebruiker aanmaken",
      "title": "Nieuwe gebruiker aanmaken",
      "subtitle": "Account direct aanmaken. Omzeilt de registratiebeperking.",
      "fieldEmail": "E-mail",
      "fieldName": "Volledige naam",
      "fieldPassword": "Wachtwoord (optioneel)",
      "passwordPlaceholder": "Leeg laten voor alleen-OAuth",
      "passwordHint": "Min. 8 tekens. Laat leeg als de gebruiker alleen via Google of LinkedIn gaat inloggen.",
      "fieldPlan": "Plan",
      "skipOnboarding": "Onboarding overslaan (maakt direct een workspace aan)",
      "submit": "Gebruiker aanmaken",
      "success": "Gebruiker aangemaakt.",
      "duplicate": "Er bestaat al een account met dit e-mailadres.",
      "failed": "Aanmaken van gebruiker mislukt."
    },
    "gate": {
      "title": "Openbare registratie",
      "statusOpen": "Nieuwe gebruikers kunnen zich aanmelden via de website.",
      "statusClosed": "Aanmeldingen zijn geblokkeerd. Bestaande gebruikers en uitgenodigde teamleden hebben geen last.",
      "actionClose": "Registratie sluiten",
      "actionOpen": "Registratie openen",
      "confirmCloseTitle": "Openbare registratie sluiten?",
      "confirmCloseMessage": "Nieuwe gebruikers kunnen zich niet aanmelden. Bestaande gebruikers en uitgenodigde teamleden hebben geen last.",
      "confirmCloseAction": "Ja, sluiten",
      "toastClosed": "Registratie is nu gesloten.",
      "toastOpen": "Registratie is nu open.",
      "updateFailed": "Bijwerken van registratie-instelling mislukt."
    }
  },
  "connectedApps": {
    "integrationsTitle": "Native integraties",
    "integrationsSubtitle": "Slack- en Discord-kanalen krijgen geformatteerde meldingen voor elk event waarop je je abonneert.",
    "webhooksTitle": "Aangepaste webhooks",
    "webhooksSubtitle": "Abonneer een eigen URL op Merkflow-events. HMAC-gesigneerde payloads, automatisch uitschakelen bij herhaaldelijke fouten.",
    "emailTitle": "Uitgaande e-mail",
    "emailSubtitle": "Per-workspace SMTP voor uitnodigingen en geautomatiseerde e-mails.",
    "ownerOnly": "Alleen voor eigenaren — vraag een workspace-eigenaar om dit te koppelen.",
    "events": {
      "post_published": "Post gepubliceerd",
      "post_failed": "Post mislukt",
      "post_approved": "Post goedgekeurd",
      "engagement_new_comment": "Nieuwe reactie of vermelding",
      "engagement_auto_replied": "Automatisch antwoord verzonden",
      "cadence_generated": "Wekelijkse posts klaar",
      "report_ready": "Rapport gegenereerd",
      "connection_unhealthy": "Verbindingsprobleem"
    },
    "webhook": {
      "add": "Webhook toevoegen",
      "addTitle": "Aangepaste webhook toevoegen",
      "editTitle": "Webhook bewerken",
      "subtitle": "POST events naar een URL van jouw keuze.",
      "nameLabel": "Naam",
      "nameCaption": "Alleen voor jezelf — wordt niet doorgegeven aan je endpoint.",
      "namePlaceholder": "Mijn CRM-webhook",
      "urlLabel": "URL",
      "urlCaption": "Ontvanger moet POST met application/json accepteren. 10 seconden timeout.",
      "secretLabel": "HMAC-secret (optioneel)",
      "secretCaption": "Bij instellen tekenen we elke payload met HMAC-SHA256 in de X-Merkflow-Signature-header. Laat leeg om niet te tekenen.",
      "secretEmptyPlaceholder": "Optioneel — laat leeg om niet te tekenen",
      "secretPresentPlaceholder": "Al ingesteld — typ om te vervangen, laat leeg om te behouden",
      "eventsLabel": "Events",
      "eventsCaption": "Kies de events die je ontvanger wil ontvangen. We sturen nooit events waarop je je niet hebt geabonneerd.",
      "test": "Test",
      "testSuccessToast": "Test-event afgeleverd — HTTP {{status}}",
      "testFailedStatusToast": "Test-event gaf HTTP {{status}}",
      "testFailedToast": "Test-event afleveren mislukt.",
      "savedToast": "Webhook bijgewerkt.",
      "createdToast": "Webhook aangemaakt.",
      "saveFailedToast": "Opslaan webhook mislukt.",
      "removedToast": "Webhook verwijderd.",
      "removeFailedToast": "Verwijderen webhook mislukt.",
      "removeConfirm": "Webhook \"{{name}}\" verwijderen? Afleveringen stoppen direct.",
      "viewDeliveries": "Afleveringen",
      "lastTriggered": "Laatst geactiveerd {{time}}",
      "neverTriggered": "Nog niet geactiveerd",
      "secretConfigured": "HMAC-signature ingesteld",
      "noEvents": "Nog geen events geabonneerd",
      "disabledPill": "Uitgeschakeld",
      "autoDisabledTitle": "Automatisch uitgeschakeld",
      "autoDisabledBody": "Uitgeschakeld na {{count}} opeenvolgende fouten. Repareer je endpoint en schakel weer in om te hervatten.",
      "reenable": "Opnieuw inschakelen",
      "reenabledToast": "Webhook opnieuw ingeschakeld.",
      "emptyTitle": "Nog geen aangepaste webhooks",
      "emptyBody": "Voeg een webhook toe om Merkflow-events op je eigen URL te ontvangen — handig voor Zapier, n8n, Make of een eigen integratie."
    },
    "integration": {
      "label": "Integratie",
      "setupSteps": "Zo stel je het in",
      "urlLabel": "Webhook-URL",
      "urlCaption": "Plak de incoming-webhook-URL van je team-app. We tonen deze nooit terug.",
      "urlEditCaption": "Opgeslagen URL eindigt op {{masked}}. Laat leeg om te behouden; plak een nieuwe om te vervangen.",
      "channelLabel": "Kanaal-label (optioneel)",
      "channelCaption": "Helpt je herkennen welk kanaal welk is op deze pagina.",
      "eventsCount": "Geabonneerde events",
      "noneSubscribed": "Geen — abonneer events om meldingen te ontvangen",
      "eventsCaption": "Kies de events die je in dit kanaal wil ontvangen.",
      "removeConfirm": "{{name}}-integratie verwijderen? Meldingen stoppen direct.",
      "connect": "Verbinden",
      "savedToast": "Integratie bijgewerkt.",
      "connectedToast": "Integratie verbonden.",
      "saveFailedToast": "Opslaan integratie mislukt.",
      "removedToast": "Integratie verwijderd.",
      "removeFailedToast": "Verwijderen integratie mislukt.",
      "testSentToast": "Test-event verstuurd — kijk in je kanaal.",
      "testFailedToast": "Test-event versturen mislukt.",
      "slack": {
        "description": "Stuur meldingen naar een Slack-kanaal via een incoming webhook. Gratis voor elke Slack-workspace.",
        "connect": "Slack verbinden",
        "connectTitle": "Slack verbinden",
        "editTitle": "Slack-integratie bewerken",
        "subtitle": "Stuur meldingen naar een Slack-kanaal voor elk gekozen event.",
        "step1": "Open api.slack.com/apps, maak een nieuwe app aan, schakel Incoming Webhooks in.",
        "step2": "Voeg een webhook toe aan het kanaal waar je meldingen wil.",
        "step3": "Kopieer de URL die Slack geeft en plak hieronder."
      },
      "discord": {
        "description": "Stuur meldingen naar een Discord-kanaal via een incoming webhook. Gratis voor elke Discord-server.",
        "connect": "Discord verbinden",
        "connectTitle": "Discord verbinden",
        "editTitle": "Discord-integratie bewerken",
        "subtitle": "Stuur meldingen naar een Discord-kanaal voor elk gekozen event.",
        "step1": "Open in Discord: Server Settings → Integrations → Webhooks → New Webhook.",
        "step2": "Kies het kanaal, geef de bot een naam, optioneel een eigen avatar.",
        "step3": "Kopieer de webhook-URL en plak hieronder."
      }
    },
    "deliveries": {
      "title": "Recente afleveringen",
      "empty": "Nog geen afleveringen. Stuur een test-event of wacht op het volgende geabonneerde event.",
      "deliveredAtLabel": "Afgeleverd op",
      "responseBodyLabel": "Response body"
    }
  }
}
